const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiceField(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461.8,334.25C440.89,378.1,404,423.66,359.49,432.68c-67.3,13.63-82.95,72.52-197.47,51.63a205.17,205.17,0,0,1-48.72-15.07,177.2,177.2,0,0,1-22.24-12.12C27.92,416.67,2,342.68,8.74,269.76c8.84-95.91,72.52-133.71,113.52-155.36S222.12-4.4,334.88,15.11A199.07,199.07,0,0,1,385,30.56c36.55,17,71.81,48.52,89.22,90.06q1.95,4.68,3.67,9.52C500.14,193.23,490.3,274.47,461.8,334.25Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.8,334.25C440.89,378.1,404,423.66,359.49,432.68c-67.3,13.63-82.95,72.52-197.47,51.63a205.17,205.17,0,0,1-48.72-15.07,177.2,177.2,0,0,1-22.24-12.12C27.92,416.67,2,342.68,8.74,269.76c8.84-95.91,72.52-133.71,113.52-155.36S222.12-4.4,334.88,15.11A199.07,199.07,0,0,1,385,30.56c36.55,17,71.81,48.52,89.22,90.06q1.95,4.68,3.67,9.52C500.14,193.23,490.3,274.47,461.8,334.25Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.16,66s-8.33-15.68-25-18.62-23,15.19-27.43,19.6S379.86,63.1,372,63.59s-9.8,5.38-11.27,7.83-6.92-5.62-10.07-4.52-4.58,4.57-4.58,4.57l-11.31,1.91H462.66s1-8.32-7.35-10.28S441.59,67,438.16,66Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.48,77.78s-3.64-6.86-10.93-8.15-10.07,6.65-12,8.58-2.58-1.72-6-1.5-4.28,2.35-4.93,3.43-3-2.46-4.4-2a3.87,3.87,0,0,0-2,2L23.25,81h56A4.13,4.13,0,0,0,76,76.49C72.34,75.64,70,78.21,68.48,77.78Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.93,32.14s-4.42-8.33-13.27-9.89-12.23,8.07-14.57,10.41-3.13-2.08-7.29-1.82-5.2,2.86-6,4.16-3.68-3-5.36-2.4A4.67,4.67,0,0,0,174,35l-6,1h67.92a5,5,0,0,0-3.9-5.46C227.61,29.54,224.75,32.66,222.93,32.14Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mountains--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.81,82.94c20.58,16.18,43.64,35.15,59.62,48.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.66,139.54s156.09-88.63,167-88.63c3.86,0,20.83,12.26,41.13,28.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.41,141.42S376.88,98.3,387.82,97s101.68,41.84,102.33,43.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.17,168.07c-.43-5.08-4.36-15.23-10.49-18.19-6.47-3.13-11.59,3.57-23.27,8.3s-8.51-3.74-20.61-10.44S89,150.26,84.17,152.4c-5,2.21-8.13-5.88-9.37-8.89-2.41-5.87-5.2-10.9-11.38-14.34-9.52-5.32-26-4.63-30.75,5.94-1.42,3.17-.66,8.92-4.39,10.71-5.55,2.68-20.58.08-21,8.67a12.05,12.05,0,0,0,2.64,7.72,5.71,5.71,0,0,1,.73,2.9c-.37,1.3-3.67-1.6-6.16,0a10,10,0,0,0-3.21,3.54C54.29,166.86,105.17,166.59,157.17,168.07Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.17,168.07c-.43-5.08-4.36-15.23-10.49-18.19-6.47-3.13-11.59,3.57-23.27,8.3s-8.51-3.74-20.61-10.44S89,150.26,84.17,152.4c-5,2.21-8.13-5.88-9.37-8.89-2.41-5.87-5.2-10.9-11.38-14.34-9.52-5.32-26-4.63-30.75,5.94-1.42,3.17-.66,8.92-4.39,10.71-5.55,2.68-20.58.08-21,8.67a12.05,12.05,0,0,0,2.64,7.72,5.71,5.71,0,0,1,.73,2.9c-.37,1.3-3.67-1.6-6.16,0a10,10,0,0,0-3.21,3.54C54.29,166.86,105.17,166.59,157.17,168.07Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.42,138a4.63,4.63,0,0,0,.52,3.12A10.41,10.41,0,0,0,50,143.4S50.79,140.69,47.42,138Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.08,153.33a6.14,6.14,0,0,0,3.29,1.09,11.51,11.51,0,0,0,3.22-.51S36.31,152,32.08,153.33Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.46,151.76a6.1,6.1,0,0,0,3.32,1.08,11.77,11.77,0,0,0,3.25-.53S20.71,150.39,16.46,151.76Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.22,160.46a6.14,6.14,0,0,0,3.47.16,10.89,10.89,0,0,0,2.88-1.36S33.76,158,30.22,160.46Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.43,159.05a6.34,6.34,0,0,0,3.5.14,10.92,10.92,0,0,0,2.88-1.38S18,156.59,14.43,159.05Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.74,161a5.81,5.81,0,0,0,3.19-1.15,9.72,9.72,0,0,0,2-2.33S42.83,157.41,40.74,161Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.23,166.54a5.78,5.78,0,0,0,3.18-1.17A9.55,9.55,0,0,0,24.34,163S21.25,163,19.23,166.54Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.45,139.93a5.14,5.14,0,0,0,2,2.62,11.7,11.7,0,0,0,3,1.3S39.81,141.09,35.45,139.93Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,138.23a5.85,5.85,0,0,0-3.06,1.48,9.5,9.5,0,0,0-1.7,2.53S65.31,142,67,138.23Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.72,147.17a6,6,0,0,0-3.42.42,10.43,10.43,0,0,0-2.55,1.83S70.72,150.16,73.72,147.17Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.25,157.37A5.75,5.75,0,0,0,70.13,156a11.36,11.36,0,0,0-3.23.26S69,158.38,73.25,157.37Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1,162.91a5.39,5.39,0,0,0-2.41-2.27,11.75,11.75,0,0,0-3.14-.8S61.7,162.45,66.1,162.91Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.85,146.38a5.81,5.81,0,0,0-3,1.49,9.37,9.37,0,0,0-1.68,2.54S60.19,150.15,61.85,146.38Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.43,144.63A5.53,5.53,0,0,0,33,146.78a12.07,12.07,0,0,0,3.23.66S35,144.88,30.43,144.63Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.59,135.92a5.09,5.09,0,0,0-1.89,2.63,8.73,8.73,0,0,0-.14,3S58.11,140,57.59,135.92Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.64,131.05a4.63,4.63,0,0,0-.41,3.13,9.24,9.24,0,0,0,1.33,2.72S54.1,134.47,51.64,131.05Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.92,132.91a4.8,4.8,0,0,0,1.25,3,11,11,0,0,0,2.58,1.88S42.88,134.94,38.92,132.91Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.29,150.94a2.72,2.72,0,0,0,.26,1.81,5.71,5.71,0,0,0,1.15,1.37S96.18,152.56,94.29,150.94Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.31,159.69a3.43,3.43,0,0,0,1.85.67A6.53,6.53,0,0,0,89,160.1,3.88,3.88,0,0,0,85.31,159.69Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1,163.8a3.49,3.49,0,0,0,2,.13,6.37,6.37,0,0,0,1.68-.75A3.87,3.87,0,0,0,84.1,163.8Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1,164.22a3.32,3.32,0,0,0,1.85-.63,5.93,5.93,0,0,0,1.18-1.33A3.66,3.66,0,0,0,90.1,164.22Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.46,152a2.92,2.92,0,0,0,1.08,1.54,6.56,6.56,0,0,0,1.68.79S89.92,152.68,87.46,152Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.49,151.28a3.34,3.34,0,0,0-1.77.84,5.36,5.36,0,0,0-1,1.45A3.63,3.63,0,0,0,105.49,151.28Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.25,156.53a3.42,3.42,0,0,0-2,.21,6.1,6.1,0,0,0-1.49,1A3.84,3.84,0,0,0,109.25,156.53Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.85,162.45a3.28,3.28,0,0,0-1.78-.81,6.73,6.73,0,0,0-1.86.12S106.36,163,108.85,162.45Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.64,165.59a3,3,0,0,0-1.35-1.33,6.61,6.61,0,0,0-1.8-.5S102.11,165.29,104.64,165.59Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.44,156a3.36,3.36,0,0,0-1.76.83,5.59,5.59,0,0,0-1,1.46A3.6,3.6,0,0,0,102.44,156Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.53,154.63A3.05,3.05,0,0,0,86,155.9a6.61,6.61,0,0,0,1.83.42S87.1,154.82,84.53,154.63Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.12,149.86A2.94,2.94,0,0,0,99,151.37a5.19,5.19,0,0,0-.11,1.72A3.23,3.23,0,0,0,100.12,149.86Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.77,147a2.74,2.74,0,0,0-.26,1.81,5.52,5.52,0,0,0,.73,1.59S98.14,149,96.77,147Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.52,147.93a2.77,2.77,0,0,0,.67,1.72,6.31,6.31,0,0,0,1.44,1.12S91.74,149.14,89.52,147.93Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.27,155.31a2.71,2.71,0,0,0,.21,1.82,5.66,5.66,0,0,0,1.11,1.39S141.12,157,139.27,155.31Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,163.89a3.33,3.33,0,0,0,1.83.7,6.65,6.65,0,0,0,1.86-.22A3.86,3.86,0,0,0,130,163.89Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.41,156.2a2.92,2.92,0,0,0,1,1.56,6.39,6.39,0,0,0,1.65.82S134.85,157,132.41,156.2Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.48,155.86a3.39,3.39,0,0,0-1.8.8,5.75,5.75,0,0,0-1.05,1.43A3.66,3.66,0,0,0,150.48,155.86Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.11,161.17a3.54,3.54,0,0,0-2,.18,6.11,6.11,0,0,0-1.53,1A3.92,3.92,0,0,0,154.11,161.17Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.51,167.08a3.27,3.27,0,0,0-1.76-.84,6.64,6.64,0,0,0-1.87.09S151,167.58,153.51,167.08Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.29,160.49a3.36,3.36,0,0,0-1.8.8,5.69,5.69,0,0,0-1,1.44A3.69,3.69,0,0,0,147.29,160.49Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.41,158.82a3.12,3.12,0,0,0,1.39,1.3,6.78,6.78,0,0,0,1.81.45S132,159.06,129.41,158.82Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.14,154.33a3.09,3.09,0,0,0-1.16,1.5,5.41,5.41,0,0,0-.16,1.72A3.3,3.3,0,0,0,145.14,154.33Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.86,151.39a2.8,2.8,0,0,0-.31,1.81,5.42,5.42,0,0,0,.69,1.6S143.18,153.43,141.86,151.39Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.58,152.21a2.77,2.77,0,0,0,.63,1.73,5.82,5.82,0,0,0,1.41,1.15S136.77,153.47,134.58,152.21Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.57,167.52l4.14-.07q-1.1-4.26-2.18-8.52,4.2-3.17,8.45-6.32L45.28,157Q43.65,151,42,144.91q1.54,11.09,3.23,22.17l-6.16-2L27.4,161.24q6.52,3.06,13,6.14Z",
    style: {
      fill: "#616161"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.59,155.6q-2.78,5.53-5.48,11.08l2.3.22c.45-1.07.91-2.13,1.36-3.2l6.17-1-5.72-1.13Q94.9,158.59,95.59,155.6Z",
    style: {
      fill: "#616161"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.58,161.39l3.08,6c.22-1.07.44-2.14.65-3.21Z",
    style: {
      fill: "#616161"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.45,167.7c.2-1.44.4-2.88.59-4.33l4.25-2.81-3.94.54q.43-3.07.85-6.16-2.28,6.24-4.54,12.49l1.38.24Z",
    style: {
      fill: "#616161"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.7,168.07c-.43-5.08-4.36-15.23-10.49-18.19-6.47-3.13-11.59,3.57-23.27,8.3s-8.5-3.74-20.61-10.44-13.78,2.52-18.63,4.66c-5,2.21-8.13-5.88-9.36-8.89-2.42-5.87-5.21-10.9-11.39-14.34-9.52-5.32-26-4.63-30.75,5.94-1.42,3.17-.66,8.92-4.39,10.71-5.55,2.68-20.58.08-21,8.67a12.05,12.05,0,0,0,2.64,7.72,5.74,5.74,0,0,1,.74,2.9c-.38,1.3-3.68-1.6-6.17,0a10,10,0,0,0-3.21,3.54C182.82,166.86,233.7,166.59,285.7,168.07Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.7,168.07c-.43-5.08-4.36-15.23-10.49-18.19-6.47-3.13-11.59,3.57-23.27,8.3s-8.5-3.74-20.61-10.44-13.78,2.52-18.63,4.66c-5,2.21-8.13-5.88-9.36-8.89-2.42-5.87-5.21-10.9-11.39-14.34-9.52-5.32-26-4.63-30.75,5.94-1.42,3.17-.66,8.92-4.39,10.71-5.55,2.68-20.58.08-21,8.67a12.05,12.05,0,0,0,2.64,7.72,5.74,5.74,0,0,1,.74,2.9c-.38,1.3-3.68-1.6-6.17,0a10,10,0,0,0-3.21,3.54C182.82,166.86,233.7,166.59,285.7,168.07Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,138a4.63,4.63,0,0,0,.52,3.12,10.41,10.41,0,0,0,2.07,2.33S179.32,140.69,176,138Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.61,153.33a6.14,6.14,0,0,0,3.29,1.09,11.51,11.51,0,0,0,3.22-.51S164.84,152,160.61,153.33Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,151.76a6.1,6.1,0,0,0,3.32,1.08,11.68,11.68,0,0,0,3.25-.53S149.24,150.39,145,151.76Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.75,160.46a6.14,6.14,0,0,0,3.47.16,10.89,10.89,0,0,0,2.88-1.36S162.3,158,158.75,160.46Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,159.05a6.34,6.34,0,0,0,3.5.14,10.73,10.73,0,0,0,2.88-1.38S146.5,156.59,143,159.05Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.27,161a5.81,5.81,0,0,0,3.19-1.15,9.72,9.72,0,0,0,2-2.33S171.36,157.41,169.27,161Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.76,166.54a5.78,5.78,0,0,0,3.18-1.17,9.55,9.55,0,0,0,1.93-2.36S149.78,163,147.76,166.54Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,139.93a5.14,5.14,0,0,0,2,2.62,11.68,11.68,0,0,0,3,1.3S168.35,141.09,164,139.93Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.53,138.23a5.85,5.85,0,0,0-3.06,1.48,9.5,9.5,0,0,0-1.7,2.53S193.84,142,195.53,138.23Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.25,147.17a6.05,6.05,0,0,0-3.42.42,10.43,10.43,0,0,0-2.55,1.83S199.25,150.16,202.25,147.17Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.78,157.37a5.75,5.75,0,0,0-3.12-1.34,11.36,11.36,0,0,0-3.23.26S197.5,158.38,201.78,157.37Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.63,162.91a5.39,5.39,0,0,0-2.41-2.27,11.75,11.75,0,0,0-3.14-.8S190.23,162.45,194.63,162.91Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.38,146.38a5.81,5.81,0,0,0-3,1.49,9.37,9.37,0,0,0-1.68,2.54S188.72,150.15,190.38,146.38Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,144.63a5.53,5.53,0,0,0,2.59,2.15,12.07,12.07,0,0,0,3.23.66S163.49,144.88,159,144.63Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.12,135.92a5.09,5.09,0,0,0-1.89,2.63,8.73,8.73,0,0,0-.14,3S186.64,140,186.12,135.92Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.17,131.05a4.63,4.63,0,0,0-.41,3.13,9.24,9.24,0,0,0,1.33,2.72S182.63,134.47,180.17,131.05Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.45,132.91a4.8,4.8,0,0,0,1.25,3,11,11,0,0,0,2.58,1.88S171.41,134.94,167.45,132.91Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.82,150.94a2.72,2.72,0,0,0,.26,1.81,5.71,5.71,0,0,0,1.15,1.37S224.71,152.56,222.82,150.94Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.84,159.69a3.43,3.43,0,0,0,1.85.67,6.44,6.44,0,0,0,1.85-.26A3.86,3.86,0,0,0,213.84,159.69Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.63,163.8a3.49,3.49,0,0,0,2,.13,6.37,6.37,0,0,0,1.68-.75A3.87,3.87,0,0,0,212.63,163.8Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.63,164.22a3.32,3.32,0,0,0,1.85-.63,5.63,5.63,0,0,0,1.18-1.33A3.66,3.66,0,0,0,218.63,164.22Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,152a2.92,2.92,0,0,0,1.08,1.54,6.73,6.73,0,0,0,1.68.79S218.45,152.68,216,152Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,151.28a3.34,3.34,0,0,0-1.77.84,5.36,5.36,0,0,0-1,1.45A3.63,3.63,0,0,0,234,151.28Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.78,156.53a3.42,3.42,0,0,0-2,.21,6.1,6.1,0,0,0-1.49,1A3.84,3.84,0,0,0,237.78,156.53Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.38,162.45a3.28,3.28,0,0,0-1.78-.81,6.73,6.73,0,0,0-1.86.12S234.89,163,237.38,162.45Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.17,165.59a3,3,0,0,0-1.35-1.33,6.61,6.61,0,0,0-1.8-.5S230.64,165.29,233.17,165.59Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,156a3.36,3.36,0,0,0-1.76.83,5.59,5.59,0,0,0-1,1.46A3.6,3.6,0,0,0,231,156Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.06,154.63a3.05,3.05,0,0,0,1.43,1.27,6.61,6.61,0,0,0,1.83.42S215.63,154.82,213.06,154.63Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.65,149.86a2.94,2.94,0,0,0-1.11,1.51,5.19,5.19,0,0,0-.11,1.72A3.23,3.23,0,0,0,228.65,149.86Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.3,147a2.74,2.74,0,0,0-.26,1.81,5.52,5.52,0,0,0,.73,1.59S226.67,149,225.3,147Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.05,147.93a2.77,2.77,0,0,0,.67,1.72,6.24,6.24,0,0,0,1.45,1.12S220.27,149.14,218.05,147.93Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.8,155.31a2.78,2.78,0,0,0,.21,1.82,5.66,5.66,0,0,0,1.11,1.39S269.65,157,267.8,155.31Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.56,163.89a3.33,3.33,0,0,0,1.83.7,6.65,6.65,0,0,0,1.86-.22A3.86,3.86,0,0,0,258.56,163.89Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.94,156.2a2.92,2.92,0,0,0,1,1.56,6.39,6.39,0,0,0,1.65.82S263.38,157,260.94,156.2Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,155.86a3.38,3.38,0,0,0-1.81.8,5.75,5.75,0,0,0-1,1.43A3.68,3.68,0,0,0,279,155.86Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.64,161.17a3.54,3.54,0,0,0-2,.18,6.11,6.11,0,0,0-1.53,1A3.92,3.92,0,0,0,282.64,161.17Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,167.08a3.27,3.27,0,0,0-1.76-.84,6.64,6.64,0,0,0-1.87.09S279.52,167.58,282,167.08Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.82,160.49a3.36,3.36,0,0,0-1.8.8,5.69,5.69,0,0,0-1,1.44A3.69,3.69,0,0,0,275.82,160.49Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.94,158.82a3.12,3.12,0,0,0,1.39,1.3,6.81,6.81,0,0,0,1.82.45S260.5,159.06,257.94,158.82Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.67,154.33a3,3,0,0,0-1.15,1.5,5.25,5.25,0,0,0-.17,1.72A3.3,3.3,0,0,0,273.67,154.33Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.4,151.39a2.7,2.7,0,0,0-.32,1.81,5.42,5.42,0,0,0,.69,1.6S271.71,153.43,270.4,151.39Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.11,152.21a2.77,2.77,0,0,0,.63,1.73,6,6,0,0,0,1.41,1.15S265.3,153.47,263.11,152.21Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.1,167.52l4.14-.07q-1.1-4.26-2.18-8.52,4.2-3.17,8.45-6.32l-9.7,4.42q-1.63-6.06-3.26-12.12,1.55,11.09,3.23,22.17l-6.16-2-11.69-3.81q6.52,3.06,13,6.14Z",
    style: {
      fill: "#616161"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.12,155.6q-2.77,5.53-5.48,11.08l2.3.22c.45-1.07.91-2.13,1.36-3.2l6.18-1-5.73-1.13Q223.43,158.59,224.12,155.6Z",
    style: {
      fill: "#616161"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.11,161.39l3.08,6,.66-3.21Z",
    style: {
      fill: "#616161"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,167.7c.2-1.44.4-2.88.59-4.33l4.25-2.81-3.94.54q.44-3.07.85-6.16-2.28,6.24-4.54,12.49l1.38.24Z",
    style: {
      fill: "#616161"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.71,168.22c.31-3.74,3.21-11.22,7.72-13.4,4.77-2.31,8.54,2.63,17.14,6.11s6.27-2.75,15.19-7.69,10.15,1.86,13.72,3.43,6-4.33,6.9-6.54c1.79-4.33,3.84-8,8.39-10.57,7-3.92,19.14-3.41,22.65,4.37,1.05,2.34.49,6.58,3.24,7.9,4.09,2,15.16,0,15.46,6.38a8.85,8.85,0,0,1-1.94,5.69,4.15,4.15,0,0,0-.54,2.14c.27,1,2.7-1.18,4.54,0a7.57,7.57,0,0,1,2.36,2.61C326.5,167.33,289,167.12,250.71,168.22Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.71,168.22c.31-3.74,3.21-11.22,7.72-13.4,4.77-2.31,8.54,2.63,17.14,6.11s6.27-2.75,15.19-7.69,10.15,1.86,13.72,3.43,6-4.33,6.9-6.54c1.79-4.33,3.84-8,8.39-10.57,7-3.92,19.14-3.41,22.65,4.37,1.05,2.34.49,6.58,3.24,7.9,4.09,2,15.16,0,15.46,6.38a8.85,8.85,0,0,1-1.94,5.69,4.15,4.15,0,0,0-.54,2.14c.27,1,2.7-1.18,4.54,0a7.57,7.57,0,0,1,2.36,2.61C326.5,167.33,289,167.12,250.71,168.22Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.56,146a3.41,3.41,0,0,1-.39,2.3,7.48,7.48,0,0,1-1.52,1.71S329.08,148.05,331.56,146Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.86,157.36a4.47,4.47,0,0,1-2.42.8,8.3,8.3,0,0,1-2.38-.38S339.74,156.36,342.86,157.36Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.37,156.2a4.59,4.59,0,0,1-2.45.8,8.53,8.53,0,0,1-2.39-.39S351.24,155.2,354.37,156.2Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.23,162.61a4.58,4.58,0,0,1-2.56.12,8.09,8.09,0,0,1-2.12-1A5,5,0,0,1,344.23,162.61Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.86,161.57a4.67,4.67,0,0,1-2.57.11,8.09,8.09,0,0,1-2.13-1A5.09,5.09,0,0,1,355.86,161.57Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.48,163a4.28,4.28,0,0,1-2.35-.84,6.91,6.91,0,0,1-1.46-1.72A4.63,4.63,0,0,1,336.48,163Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.33,167.09a4.21,4.21,0,0,1-2.35-.87,7.13,7.13,0,0,1-1.42-1.73A4.58,4.58,0,0,1,352.33,167.09Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.38,147.48a3.78,3.78,0,0,1-1.46,1.93,8.27,8.27,0,0,1-2.2,1S337.16,148.34,340.38,147.48Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.13,146.23a4.38,4.38,0,0,1,2.26,1.09,6.87,6.87,0,0,1,1.25,1.87A4.62,4.62,0,0,1,317.13,146.23Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.18,152.82a4.41,4.41,0,0,1,2.52.31,7.66,7.66,0,0,1,1.88,1.35A4.94,4.94,0,0,1,312.18,152.82Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.53,160.34a4.21,4.21,0,0,1,2.29-1,8.38,8.38,0,0,1,2.39.19S315.69,161.08,312.53,160.34Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.79,164.41a3.93,3.93,0,0,1,1.78-1.66,8.58,8.58,0,0,1,2.31-.6S321,164.08,317.79,164.41Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.93,152.24a4.31,4.31,0,0,1,2.24,1.1,6.78,6.78,0,0,1,1.23,1.87A4.57,4.57,0,0,1,320.93,152.24Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.08,151a4.08,4.08,0,0,1-1.91,1.58,8.63,8.63,0,0,1-2.38.49S340.74,151.13,344.08,151Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.07,144.53a3.72,3.72,0,0,1,1.39,1.94,6.26,6.26,0,0,1,.1,2.19A4.08,4.08,0,0,1,324.07,144.53Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.45,141a3.41,3.41,0,0,1,.3,2.3,6.84,6.84,0,0,1-1,2S326.64,143.47,328.45,141Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.82,142.32a3.5,3.5,0,0,1-.92,2.17,8.26,8.26,0,0,1-1.9,1.38S334.91,143.81,337.82,142.32Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,155.6a2,2,0,0,1-.19,1.33,4.2,4.2,0,0,1-.85,1A2.36,2.36,0,0,1,297,155.6Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.65,162a2.54,2.54,0,0,1-1.37.5,4.85,4.85,0,0,1-1.36-.2A2.87,2.87,0,0,1,303.65,162Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.54,165.07a2.57,2.57,0,0,1-1.46.1,4.57,4.57,0,0,1-1.23-.56A2.86,2.86,0,0,1,304.54,165.07Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.12,165.38a2.52,2.52,0,0,1-1.37-.46,4.54,4.54,0,0,1-.87-1A2.68,2.68,0,0,1,300.12,165.38Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.06,156.35a2.17,2.17,0,0,1-.8,1.13,4.55,4.55,0,0,1-1.23.58S300.25,156.88,302.06,156.35Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.78,155.85a2.48,2.48,0,0,1,1.3.61,4,4,0,0,1,.74,1.08A2.66,2.66,0,0,1,288.78,155.85Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,159.71a2.62,2.62,0,0,1,1.46.16,4.66,4.66,0,0,1,1.1.77A2.86,2.86,0,0,1,286,159.71Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.3,164.07a2.45,2.45,0,0,1,1.31-.59,4.94,4.94,0,0,1,1.38.09A2.84,2.84,0,0,1,286.3,164.07Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.4,166.39a2.28,2.28,0,0,1,1-1,4.91,4.91,0,0,1,1.32-.37A2.68,2.68,0,0,1,289.4,166.39Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,159.3a2.42,2.42,0,0,1,1.3.62,3.92,3.92,0,0,1,.74,1.07A2.66,2.66,0,0,1,291,159.3Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.22,158.31a2.32,2.32,0,0,1-1.06.94,4.54,4.54,0,0,1-1.34.31A2.74,2.74,0,0,1,304.22,158.31Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.73,154.8a2.14,2.14,0,0,1,.82,1.11,3.74,3.74,0,0,1,.09,1.27A2.38,2.38,0,0,1,292.73,154.8Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.2,152.68a2,2,0,0,1,.19,1.33,4,4,0,0,1-.53,1.18A2.3,2.3,0,0,1,295.2,152.68Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.55,153.38a2.11,2.11,0,0,1-.5,1.27,4.5,4.5,0,0,1-1.07.82S298.91,154.27,300.55,153.38Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.89,158.82a2,2,0,0,1-.15,1.34,4.42,4.42,0,0,1-.82,1A2.33,2.33,0,0,1,263.89,158.82Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.7,165.14a2.47,2.47,0,0,1-1.35.52,5.23,5.23,0,0,1-1.37-.17A2.85,2.85,0,0,1,270.7,165.14Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,159.47a2.22,2.22,0,0,1-.77,1.15,4.89,4.89,0,0,1-1.22.61S267.15,160,269,159.47Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.63,159.22a2.57,2.57,0,0,1,1.33.59,4.07,4.07,0,0,1,.77,1.06A2.7,2.7,0,0,1,255.63,159.22Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,163.13a2.62,2.62,0,0,1,1.46.14,4.5,4.5,0,0,1,1.13.74A2.87,2.87,0,0,1,253,163.13Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.4,167.49a2.37,2.37,0,0,1,1.3-.62,5,5,0,0,1,1.38.07A2.84,2.84,0,0,1,253.4,167.49Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,162.63a2.57,2.57,0,0,1,1.33.59,4.26,4.26,0,0,1,.77,1.06A2.71,2.71,0,0,1,258,162.63Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.16,161.4a2.27,2.27,0,0,1-1,1,4.93,4.93,0,0,1-1.34.33A2.71,2.71,0,0,1,271.16,161.4Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.56,158.1a2.24,2.24,0,0,1,.86,1.1,3.88,3.88,0,0,1,.12,1.26A2.4,2.4,0,0,1,259.56,158.1Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,155.93a2,2,0,0,1,.23,1.33,3.94,3.94,0,0,1-.51,1.18A2.29,2.29,0,0,1,262,155.93Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.35,156.53a2.07,2.07,0,0,1-.47,1.28,4.34,4.34,0,0,1-1,.84S265.73,157.46,267.35,156.53Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.66,167.81l-3.05-.05q.81-3.13,1.6-6.27c-2.06-1.56-4.14-3.11-6.22-4.66l7.14,3.25q1.22-4.46,2.41-8.93-1.14,8.17-2.38,16.34l4.53-1.49c2.86-.95,5.73-1.88,8.62-2.81q-4.81,2.25-9.56,4.52Z",
    style: {
      fill: "#616161"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.07,159q2,4.08,4,8.17l-1.7.15-1-2.35-4.55-.74,4.22-.83C296.75,162,296.41,160.5,296.07,159Z",
    style: {
      fill: "#616161"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.88,163.3c-.77,1.48-1.52,3-2.28,4.44l-.48-2.36Z",
    style: {
      fill: "#616161"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.55,168c-.15-1.07-.29-2.13-.44-3.19-1-.7-2.08-1.39-3.13-2.07l2.9.4c-.21-1.52-.41-3-.62-4.54q1.68,4.59,3.34,9.19l-1,.18Z",
    style: {
      fill: "#616161"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492,168.1c-.4-4.79-4.12-14.39-9.9-17.18-6.12-3-11,3.37-22,7.84s-8-3.53-19.48-9.86-13,2.38-17.59,4.39c-4.75,2.1-7.68-5.55-8.85-8.39-2.29-5.54-4.92-10.3-10.76-13.54-9-5-24.54-4.38-29,5.6-1.35,3-.63,8.43-4.15,10.12-5.25,2.53-19.44.07-19.83,8.19a11.42,11.42,0,0,0,2.49,7.3,5.42,5.42,0,0,1,.7,2.74c-.35,1.23-3.47-1.52-5.82,0a9.64,9.64,0,0,0-3,3.35C394.77,167,442.84,166.7,492,168.1Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492,168.1c-.4-4.79-4.12-14.39-9.9-17.18-6.12-3-11,3.37-22,7.84s-8-3.53-19.48-9.86-13,2.38-17.59,4.39c-4.75,2.1-7.68-5.55-8.85-8.39-2.29-5.54-4.92-10.3-10.76-13.54-9-5-24.54-4.38-29,5.6-1.35,3-.63,8.43-4.15,10.12-5.25,2.53-19.44.07-19.83,8.19a11.42,11.42,0,0,0,2.49,7.3,5.42,5.42,0,0,1,.7,2.74c-.35,1.23-3.47-1.52-5.82,0a9.64,9.64,0,0,0-3,3.35C394.77,167,442.84,166.7,492,168.1Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.28,139.65a4.38,4.38,0,0,0,.49,2.95,9.63,9.63,0,0,0,2,2.19S391.46,142.24,388.28,139.65Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.79,154.17a5.77,5.77,0,0,0,3.11,1,10.83,10.83,0,0,0,3-.49S377.79,152.9,373.79,154.17Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,152.7a5.86,5.86,0,0,0,3.14,1,11.22,11.22,0,0,0,3.07-.5S363.05,151.4,359,152.7Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,160.91a5.88,5.88,0,0,0,3.28.16,10.42,10.42,0,0,0,2.72-1.29S375.38,158.61,372,160.91Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.12,159.58a5.94,5.94,0,0,0,3.3.14,10.45,10.45,0,0,0,2.72-1.31S360.46,157.26,357.12,159.58Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,161.4a5.49,5.49,0,0,0,3-1.08,9.16,9.16,0,0,0,1.87-2.2S384,158,382,161.4Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.65,166.66a5.47,5.47,0,0,0,3-1.11,9,9,0,0,0,1.83-2.23S363.56,163.26,361.65,166.66Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,141.52a4.92,4.92,0,0,0,1.87,2.47,11.23,11.23,0,0,0,2.82,1.23S381.1,142.62,377,141.52Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.78,139.91a5.54,5.54,0,0,0-2.89,1.4,8.9,8.9,0,0,0-1.61,2.39S405.18,143.47,406.78,139.91Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.13,148.35a5.79,5.79,0,0,0-3.23.4,9.71,9.71,0,0,0-2.41,1.74S410.29,151.18,413.13,148.35Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.68,158a5.49,5.49,0,0,0-2.94-1.27,10.82,10.82,0,0,0-3.06.25S408.63,159,412.68,158Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.93,163.22a5.16,5.16,0,0,0-2.28-2.14,11.08,11.08,0,0,0-3-.75S401.77,162.79,405.93,163.22Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.91,147.62A5.47,5.47,0,0,0,399,149a8.75,8.75,0,0,0-1.58,2.4S400.34,151.18,401.91,147.62Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.23,146a5.25,5.25,0,0,0,2.44,2,11.22,11.22,0,0,0,3.06.62S376.51,146.19,372.23,146Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.89,137.73a4.79,4.79,0,0,0-1.79,2.49A8.24,8.24,0,0,0,396,143S398.38,141.55,397.89,137.73Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.26,133.13a4.35,4.35,0,0,0-.38,3,8.59,8.59,0,0,0,1.26,2.58S394.59,136.36,392.26,133.13Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.25,134.89a4.47,4.47,0,0,0,1.18,2.78,10.36,10.36,0,0,0,2.44,1.78S384,136.8,380.25,134.89Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.56,151.92a2.57,2.57,0,0,0,.24,1.71,5.49,5.49,0,0,0,1.09,1.3S434.34,153.45,432.56,151.92Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.07,160.18a3.21,3.21,0,0,0,1.75.64,6.46,6.46,0,0,0,1.75-.25A3.69,3.69,0,0,0,424.07,160.18Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.93,164.06a3.21,3.21,0,0,0,1.86.13,5.63,5.63,0,0,0,1.58-.71A3.64,3.64,0,0,0,422.93,164.06Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.6,164.46a3.15,3.15,0,0,0,1.74-.59,5.22,5.22,0,0,0,1.12-1.26A3.43,3.43,0,0,0,428.6,164.46Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.1,152.88a2.8,2.8,0,0,0,1,1.46,6.11,6.11,0,0,0,1.59.74S428.43,153.56,426.1,152.88Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.13,152.24a3.17,3.17,0,0,0-1.67.79,5.19,5.19,0,0,0-.95,1.37A3.41,3.41,0,0,0,443.13,152.24Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.69,157.2a3.29,3.29,0,0,0-1.86.2,5.74,5.74,0,0,0-1.41,1A3.66,3.66,0,0,0,446.69,157.2Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.31,162.79a3.08,3.08,0,0,0-1.68-.76,6.29,6.29,0,0,0-1.76.11A3.65,3.65,0,0,0,446.31,162.79Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.33,165.76a2.82,2.82,0,0,0-1.28-1.26,6,6,0,0,0-1.69-.47S439.94,165.47,442.33,165.76Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.25,156.67a3.12,3.12,0,0,0-1.66.79,5,5,0,0,0-.94,1.37A3.38,3.38,0,0,0,440.25,156.67Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.33,155.4a3,3,0,0,0,1.36,1.21,6,6,0,0,0,1.73.39S425.76,155.59,423.33,155.4Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.06,150.9a2.81,2.81,0,0,0-1.05,1.42,4.8,4.8,0,0,0-.1,1.63A3,3,0,0,0,438.06,150.9Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.9,148.17a2.57,2.57,0,0,0-.25,1.71,5.26,5.26,0,0,0,.69,1.51S436.19,150.07,434.9,148.17Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.05,149.07a2.63,2.63,0,0,0,.63,1.63,5.68,5.68,0,0,0,1.37,1.05S430.15,150.22,428.05,149.07Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.05,156.05a2.53,2.53,0,0,0,.19,1.71,5.46,5.46,0,0,0,1.05,1.32S476.79,157.61,475.05,156.05Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.32,164.15a3.19,3.19,0,0,0,1.73.67,6.33,6.33,0,0,0,1.75-.22A3.65,3.65,0,0,0,466.32,164.15Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.56,156.89a2.73,2.73,0,0,0,1,1.47,6,6,0,0,0,1.56.78S470.87,157.62,468.56,156.89Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.64,156.57a3.16,3.16,0,0,0-1.7.75,5.44,5.44,0,0,0-1,1.36A3.48,3.48,0,0,0,485.64,156.57Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.06,161.58a3.31,3.31,0,0,0-1.88.17,5.82,5.82,0,0,0-1.44,1A3.68,3.68,0,0,0,489.06,161.58Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.5,167.17a3.12,3.12,0,0,0-1.66-.8,6.45,6.45,0,0,0-1.78.09A3.65,3.65,0,0,0,488.5,167.17Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.62,160.94a3.21,3.21,0,0,0-1.7.76,5.21,5.21,0,0,0-1,1.35A3.47,3.47,0,0,0,482.62,160.94Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.73,159.36a2.87,2.87,0,0,0,1.32,1.23,6.41,6.41,0,0,0,1.71.43S468.15,159.59,465.73,159.36Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.59,155.13a2.8,2.8,0,0,0-1.09,1.4,4.88,4.88,0,0,0-.16,1.63A3.09,3.09,0,0,0,480.59,155.13Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.5,152.35a2.59,2.59,0,0,0-.3,1.7,5,5,0,0,0,.65,1.52A2.94,2.94,0,0,0,477.5,152.35Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.61,153.12a2.61,2.61,0,0,0,.6,1.64,5.8,5.8,0,0,0,1.33,1.08S472.68,154.31,470.61,153.12Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.59,167.58l3.91-.07q-1-4-2.06-8l8-6-9.16,4.17q-1.54-5.71-3.08-11.45,1.45,10.47,3.05,20.94l-5.82-1.91c-3.66-1.2-7.34-2.41-11-3.6q6.17,2.9,12.26,5.8Z",
    style: {
      fill: "#616161"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.78,156.32q-2.61,5.24-5.18,10.47l2.18.2,1.29-3,5.83-.95L432.49,162Z",
    style: {
      fill: "#616161"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.5,161.79q1.47,2.85,2.91,5.71c.21-1,.42-2,.62-3Z",
    style: {
      fill: "#616161"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.05,167.75c.19-1.36.37-2.72.56-4.09l4-2.65-3.72.51c.27-1.94.53-3.88.8-5.82q-2.16,5.9-4.29,11.8l1.31.22Z",
    style: {
      fill: "#616161"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-42"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "500.59 171.56 495.92 162.81 491.05 173.36 488.61 162.81 485.03 167.88 478.98 162.52 475.87 167.58 474.22 164.01 472.39 166.69 470 163.41 466.71 167.28 465.06 163.41 462.86 167.88 457.73 165.5 456.08 167.28 451.31 164.6 448.2 164.6 446.37 166.69 444.72 164.01 443.43 166.39 441.05 162.52 438.85 165.79 436.65 162.22 432.07 166.09 429.87 161.63 428.41 164.9 427.13 163.12 422.36 163.71 421.81 161.63 418.88 164.31 418.33 160.14 416.68 162.82 413.38 160.44 412.83 162.82 408.98 158.06 406.6 163.41 403.3 157.47 401.65 163.71 397.99 160.74 395.79 164.01 394.87 161.63 392.86 164.6 391.21 160.44 388.46 164.01 387.55 161.03 387.18 163.41 384.8 161.33 383.7 163.71 381.68 160.14 380.58 162.52 378.93 160.14 377.83 162.22 376.55 161.93 375.27 163.41 373.99 160.74 372.52 163.41 370.5 160.14 368.12 164.01 363.36 159.55 362.62 163.12 360.42 160.44 357.31 164.6 356.39 161.03 353.83 164.6 352.91 161.03 351.26 164.9 349.61 160.14 348.51 163.71 346.13 160.14 345.58 164.9 344.12 165.2 343.2 162.22 341.18 165.2 340.44 162.95 339.9 161.33 338.07 162.52 338.99 167.28 334.04 162.82 332.94 164.9 330.56 161.93 330.56 163.13 330.39 162.81 325.51 166.12 323.08 162.81 319.5 167.88 313.45 162.52 310.33 167.58 308.68 164.01 306.85 166.69 304.47 163.41 301.17 167.28 299.52 163.41 297.32 167.88 292.19 165.5 290.54 167.28 285.78 164.6 282.66 164.6 280.83 166.69 279.18 164.01 277.9 166.39 275.52 162.52 273.32 165.79 271.12 162.22 266.54 166.09 264.34 161.63 262.87 164.9 261.59 163.12 256.82 163.71 256.27 161.63 253.34 164.31 252.79 160.14 251.14 162.82 247.85 160.44 247.3 162.82 243.45 158.06 241.07 163.41 237.77 157.47 236.12 163.71 232.45 160.74 230.25 164.01 229.34 161.63 227.32 164.6 225.67 160.44 222.93 164.01 222.01 161.03 221.64 163.41 219.26 161.33 218.16 163.71 216.15 160.14 215.04 162.52 213.4 160.14 212.3 162.22 211.01 161.93 209.73 163.41 208.45 160.74 206.98 163.41 204.97 160.14 202.59 164.01 197.82 159.55 197.09 163.12 194.89 160.44 191.77 164.6 190.86 161.03 188.29 164.6 187.38 161.03 185.73 164.9 184.08 160.14 182.98 163.71 180.59 160.14 180.04 164.9 178.58 165.2 177.66 162.22 175.65 165.2 174.9 162.95 174.37 161.33 172.53 162.52 173.45 167.28 168.5 162.82 167.4 164.9 165.02 161.93 165.02 163.13 164.85 162.81 159.98 173.36 157.54 162.81 153.96 167.88 147.91 162.52 144.8 167.58 143.15 164.01 141.31 166.69 138.93 163.41 135.63 167.28 133.99 163.41 131.79 167.88 126.66 165.5 125.01 167.28 120.24 164.6 117.13 164.6 115.29 166.69 113.64 164.01 112.36 166.39 109.98 162.52 107.78 165.79 105.58 162.22 101 166.09 98.8 161.63 97.34 164.9 96.05 163.12 91.29 163.71 90.74 161.63 87.81 164.31 87.26 160.14 85.61 162.82 82.31 160.44 81.76 162.82 77.91 158.06 75.53 163.41 72.23 157.47 70.58 163.71 66.92 160.74 64.72 164.01 63.8 161.63 61.79 164.6 60.14 160.44 57.39 164.01 56.47 161.03 56.11 163.41 53.72 161.33 52.62 163.71 50.61 160.14 49.51 162.52 47.86 160.14 46.76 162.22 45.48 161.93 44.2 163.41 42.91 160.74 41.45 163.41 39.43 160.14 37.05 164.01 32.28 159.55 31.55 163.12 29.35 160.44 26.24 164.6 25.32 161.03 22.75 164.6 21.84 161.03 20.19 164.9 18.54 160.14 17.44 163.71 15.06 160.14 14.51 164.9 13.04 165.2 12.13 162.22 10.11 165.2 9.36 162.95 8.83 161.33 7 162.52 7.91 167.28 2.96 162.82 1.86 164.9 -0.52 161.93 -0.52 185.23 500.59 185.23 500.59 171.56",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "491.05 181.05 488.61 170.5 485.03 175.56 478.98 170.21 475.87 175.27 474.22 171.7 472.39 174.37 470 171.1 466.71 174.97 465.06 171.1 462.86 175.56 457.73 173.18 456.08 174.97 451.31 172.29 448.2 172.29 446.37 174.37 444.72 171.7 443.43 174.08 441.05 170.21 438.85 173.48 436.65 169.91 432.07 173.78 429.87 169.32 428.41 172.59 427.13 170.8 422.36 171.4 421.81 169.32 418.88 171.99 418.33 167.83 416.68 170.51 413.38 168.13 412.83 170.51 408.98 165.75 406.6 171.1 403.3 165.15 401.65 171.4 397.99 168.42 395.79 171.7 394.87 169.32 392.86 172.29 391.21 168.13 388.46 171.7 387.55 168.72 387.18 171.1 384.8 169.02 383.7 171.4 381.68 167.83 380.58 170.21 378.93 167.83 377.83 169.91 376.55 169.61 375.27 171.1 373.99 168.42 372.52 171.1 370.5 167.83 368.12 171.7 363.36 167.23 362.62 170.8 360.42 168.13 357.31 172.29 356.39 168.72 353.83 172.29 352.91 168.72 351.26 172.59 349.61 167.83 348.51 171.4 346.13 167.83 345.58 172.59 344.12 172.89 343.2 169.91 341.18 172.89 340.44 170.63 339.9 169.02 338.07 170.21 338.99 174.97 334.04 170.51 332.94 172.59 330.56 169.61 330.56 170.81 330.39 170.5 325.51 174.92 323.08 170.5 319.5 175.56 313.45 170.21 310.33 175.27 308.68 171.7 306.85 174.37 304.47 171.1 301.17 174.97 299.52 171.1 297.32 175.56 292.19 173.18 290.54 174.97 285.78 172.29 282.66 172.29 280.83 174.37 279.18 171.7 277.9 174.08 275.52 170.21 273.32 173.48 271.12 169.91 266.54 173.78 264.34 169.32 262.87 172.59 261.59 170.8 256.82 171.4 256.27 169.32 253.34 171.99 252.79 167.83 251.14 170.51 247.85 168.13 247.3 170.51 243.45 165.75 241.07 171.1 237.77 165.15 236.12 171.4 232.45 168.42 230.25 171.7 229.34 169.32 227.32 172.29 225.67 168.13 222.93 171.7 222.01 168.72 221.64 171.1 219.26 169.02 218.16 171.4 216.15 167.83 215.04 170.21 213.4 167.83 212.3 169.91 211.01 169.61 209.73 171.1 208.45 168.42 206.98 171.1 204.97 167.83 202.59 171.7 197.82 167.23 197.09 170.8 194.89 168.13 191.77 172.29 190.86 168.72 188.29 172.29 187.38 168.72 185.73 172.59 184.08 167.83 182.98 171.4 180.59 167.83 180.04 172.59 178.58 172.89 177.66 169.91 175.65 172.89 174.9 170.63 174.37 169.02 172.53 170.21 173.45 174.97 168.5 170.51 167.4 172.59 165.02 169.61 165.02 170.81 164.85 170.5 159.98 181.05 157.54 170.5 153.96 175.56 147.91 170.21 144.8 175.27 143.15 171.7 141.31 174.37 138.93 171.1 135.63 174.97 133.99 171.1 131.79 175.56 126.66 173.18 125.01 174.97 120.24 172.29 117.13 172.29 115.29 174.37 113.64 171.7 112.36 174.08 109.98 170.21 107.78 173.48 105.58 169.91 101 173.78 98.8 169.32 97.34 172.59 96.05 170.8 91.29 171.4 90.74 169.32 87.81 171.99 87.26 167.83 85.61 170.51 82.31 168.13 81.76 170.51 77.91 165.75 75.53 171.1 72.23 165.15 70.58 171.4 66.92 168.42 64.72 171.7 63.8 169.32 61.79 172.29 60.14 168.13 57.39 171.7 56.47 168.72 56.11 171.1 53.72 169.02 52.62 171.4 50.61 167.83 49.51 170.21 47.86 167.83 46.76 169.91 45.48 169.61 44.2 171.1 42.91 168.42 41.45 171.1 39.43 167.83 37.05 171.7 32.28 167.23 31.55 170.8 29.35 168.13 26.24 172.29 25.32 168.72 22.75 172.29 21.84 168.72 20.19 172.59 18.54 167.83 17.44 171.4 15.06 167.83 14.51 172.59 13.04 172.89 12.13 169.91 10.11 172.89 9.36 170.63 8.83 169.02 7 170.21 7.91 174.97 2.96 170.51 1.86 172.59 -0.52 169.61 -0.52 185.23 500.59 185.23 500.59 179.25 495.92 170.5 491.05 181.05",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.54,205.9s4.74-4.21,9.48-2.11l4.73,2.11a28,28,0,0,1,3.16-.26,12.72,12.72,0,0,1,3.68,1.05s-1.05-1.32,2.37-1.05a8.74,8.74,0,0,1,5.26,2.1l3.69.53,1.84.79,7.1.79H221.91Z",
    style: {
      fill: "#737373"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.16 304.18 285.2 297.83 280.97 300.37 280.12 291.06 275.47 293.18 274.62 288.94 270.81 291.06 270.39 284.71 268.27 288.1 268.27 277.1 263.2 275.83 264.04 269.06 259.81 270.33 256.85 267.79 254.74 257.64 251.77 260.18 250.08 252.14 247.12 252.98 246.27 248.75 241.2 249.18 241.62 244.94 238.24 244.52 238.66 240.71 234.85 241.98 231.89 236.06 232.74 226.75 229.77 228.02 227.66 223.37 226.39 226.75 223.85 217.44 221.31 220.83 220.47 216.18 217.08 218.71 216.66 213.21 213.7 214.91 213.27 208.14 209.04 210.68 210.31 203.48 205.66 206.02 203.12 198.41 201.85 202.21 198.04 198.83 197.51 195.29 196.77 190.37 195.08 193.75 193.39 187.41 192.12 192.06 188.74 190.79 187.47 184.87 184.5 186.14 181.97 181.48 177.74 184.02 172.24 177.68 167.16 184.44 164.62 177.68 160.89 180.93 154.59 177.49 151.34 180.74 149.63 178.44 147.72 180.16 145.24 178.06 141.8 180.54 140.08 178.06 137.79 180.93 132.45 179.4 130.73 180.54 125.77 178.83 122.52 178.83 120.61 180.16 118.89 178.44 117.56 179.97 115.08 177.49 112.78 179.59 110.49 177.3 105.72 179.78 103.43 176.92 101.9 179.02 100.57 177.87 95.6 178.25 95.03 176.92 91.98 178.64 91.4 175.96 89.69 177.68 86.25 176.15 85.68 177.68 81.67 174.63 79.19 178.06 75.75 174.25 74.03 178.25 70.21 176.34 67.92 178.44 66.97 176.92 64.87 178.83 63.15 176.15 60.29 178.44 59.33 176.54 58.95 178.06 56.47 176.73 55.32 178.25 53.22 175.96 52.08 177.49 50.36 175.96 49.22 177.3 47.88 177.11 46.54 178.06 45.21 176.34 43.68 178.06 41.58 175.96 39.1 178.44 34.13 175.58 33.37 177.87 31.08 176.15 27.83 178.83 26.88 176.54 24.21 178.83 23.25 176.54 21.54 179.02 19.82 175.96 18.67 178.25 16.19 175.96 15.62 179.02 14.09 179.21 13.13 177.3 11.04 179.21 10.26 177.76 9.7 176.73 7.79 177.49 8.74 180.54 3.59 177.68 2.44 179.02 -0.04 177.11 -0.04 193.34 0.15 193.35 0.15 329.93 295.79 329.93 296.2 299.1 288.16 304.18",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.64,303.24l-1.48.94-3-6.35L281,300.37l-.85-9.31-4.65,2.12-.85-4.24-3.81,2.12-.42-6.35-2.12,3.39v-6.38l-5.3.19-.52-4.72-2.1,2.9-.79-4.36-2.1,4.73-.68,1.47c-.63,1.37-1.57,3.38-2.21,4.71-1,2.18-1.31-5.09-1.31-5.09l-1,2.91-3.68-6.18L244.07,283l-1.58-4.36-2.1,2.91-1.31-4-2.37,6.18-1.31-5.09-1.05,5.82-2.89-5.82-.26,3.64-1.84-1.82-1.31,3.63-2.36-6.18L221,281.55l-.53-9.09-2.88,8-2.37-5.82-1.57,6.18L212,276.09,210.46,279l-1.58-2.91-1.84,4-2.36-3.63-1.58,6.91-2.88-2.91-2.37,1.45-.52-4.72-2.1,2.9-.79-4.36-2.1,4.73-.68,1.47c-.63,1.37-1.57,3.38-2.21,4.71-1,2.18-1.31-5.09-1.31-5.09l-1,2.91-3.68-6.18L179,283l-1.58-4.36-2.1,2.91-1.31-4-2.36,6.18-1.32-5.09-1.05,5.82-2.89-5.82-.26,3.64-1.84-1.82-1.31,3.63-2.36-6.18-4.73,3.64-.52-9.09-2.89,8-2.37-5.82-1.57,6.18-1.58-4.73L145.34,279l-1.58-2.91-1.84,4-2.36-3.63L133,281.91l-.53-4.72-2.1,2.9-.79-4.36-2.1,4.73-.68,1.47c-.63,1.37-1.56,3.38-2.21,4.71-1,2.18-1.31-5.09-1.31-5.09l-1,2.91-3.67-6.18L114.09,283l-1.57-4.36-2.1,2.91-1.32-4-2.36,6.18-1.31-5.09-1.05,5.82-2.89-5.82-.26,3.64-1.84-1.82-1.32,3.63-2.36-6.18L91,281.55l-.53-9.09-2.89,8-2.36-5.82-1.58,6.18-1.57-4.73L80.48,279l-1.57-2.91-1.84,4-2.36-3.63-1.58,6.91-2.89-2.91-2.36,1.45-.53-4.72-2.1,2.9-.79-4.36-2.1,4.73s-.27.6-.68,1.47c-.63,1.37-1.56,3.38-2.2,4.71-1,2.18-1.32-5.09-1.32-5.09l-1,2.91-3.67-6.18L49,283l-1.57-4.36-2.1,2.91-1.32-4-2.36,6.18-1.31-5.09-1.05,5.82-2.89-5.82-.26,3.64-1.84-1.82L33,284.09l-2.37-6.18-4.72,3.64-.53-9.09-2.89,8-2.36-5.82-1.58,6.18-1.57-4.73L15.36,279l-1.57-2.91-1.84,4-2.36-3.63L8,283.37l-2.89-2.91,1,4-6,.43v45H293Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.15 383.72 192.91 379.07 191.64 383.72 194.15 383.72",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "500.59 373.85 495.92 365.1 491.05 375.65 488.61 365.1 485.03 370.16 478.98 364.81 475.87 369.86 474.22 366.29 472.39 368.97 470 365.7 466.71 369.57 465.06 365.7 462.86 370.16 457.73 367.78 456.08 369.57 451.31 366.89 448.2 366.89 446.37 368.97 444.72 366.29 443.43 368.67 441.05 364.81 438.85 368.08 436.65 364.51 432.07 368.38 429.87 363.91 428.41 367.19 427.13 365.4 422.36 366 421.81 363.91 418.88 366.59 418.33 362.43 416.68 365.1 413.38 362.72 412.83 365.1 408.98 360.34 406.6 365.7 403.3 359.75 401.65 366 397.99 363.02 395.79 366.29 394.87 363.91 392.86 366.89 391.21 362.72 388.46 366.29 387.55 363.32 387.18 365.7 384.8 363.62 383.7 366 381.68 362.43 380.58 364.81 378.93 362.43 377.83 364.51 376.55 364.21 375.27 365.7 373.99 363.02 372.52 365.7 370.5 362.43 368.12 366.29 363.36 361.83 362.62 365.4 360.42 362.72 357.31 366.89 356.39 363.32 353.83 366.89 352.91 363.32 351.26 367.19 349.61 362.43 348.51 366 346.13 362.43 345.58 367.19 344.12 367.48 343.2 364.51 341.18 367.48 340.44 365.23 339.9 363.62 338.07 364.81 338.99 369.57 334.04 365.1 332.94 367.19 330.56 364.21 330.56 365.41 330.39 365.1 325.51 375.65 323.08 365.1 319.5 370.16 313.45 364.81 310.33 369.86 308.68 366.29 306.85 368.97 304.47 365.7 301.17 369.57 299.52 365.7 297.32 370.16 292.19 367.78 290.54 369.57 285.78 366.89 282.66 366.89 280.83 368.97 279.18 366.29 277.9 368.67 275.52 364.81 273.32 368.08 271.12 364.51 266.54 368.38 264.34 363.91 262.87 367.19 261.59 365.4 256.82 366 256.27 363.91 253.34 366.59 252.79 362.43 251.14 365.1 247.85 362.72 247.3 365.1 243.45 360.34 241.07 365.7 237.77 359.75 236.12 366 232.45 363.02 230.25 366.29 229.34 363.91 227.32 366.89 225.67 362.72 222.93 366.29 222.01 363.32 221.64 365.7 219.26 363.62 218.16 366 216.15 362.43 215.04 364.81 213.4 362.43 212.3 364.51 211.01 364.21 209.73 365.7 208.45 363.02 206.98 365.7 204.97 362.43 202.59 366.29 197.82 361.83 197.09 365.4 194.89 362.72 191.77 366.89 190.86 363.32 188.29 366.89 187.38 363.32 185.73 367.19 184.08 362.43 182.98 366 180.59 362.43 180.04 367.19 178.58 367.48 177.66 364.51 175.65 367.48 174.9 365.23 174.37 363.62 172.53 364.81 173.45 369.57 168.5 365.1 167.4 367.19 165.02 364.21 165.02 365.41 164.85 365.1 159.98 375.65 157.54 365.1 153.96 370.16 147.91 364.81 144.8 369.86 143.15 366.29 141.31 368.97 138.93 365.7 135.63 369.57 133.99 365.7 131.79 370.16 126.66 367.78 125.01 369.57 120.24 366.89 117.13 366.89 115.29 368.97 113.64 366.29 112.36 368.67 109.98 364.81 107.78 368.08 105.58 364.51 101 368.38 98.8 363.91 97.34 367.19 96.05 365.4 91.29 366 90.74 363.91 87.81 366.59 87.26 362.43 85.61 365.1 82.31 362.72 81.76 365.1 77.91 360.34 75.53 365.7 72.23 359.75 70.58 366 66.92 363.02 64.72 366.29 63.8 363.91 61.79 366.89 60.14 362.72 57.39 366.29 56.47 363.32 56.11 365.7 53.72 363.62 52.62 366 50.61 362.43 49.51 364.81 47.86 362.43 46.76 364.51 45.48 364.21 44.2 365.7 42.91 363.02 41.45 365.7 39.43 362.43 37.05 366.29 32.28 361.83 31.55 365.4 29.35 362.72 26.24 366.89 25.32 363.32 22.75 366.89 21.84 363.32 20.19 367.19 18.54 362.43 17.44 366 15.06 362.43 14.51 367.19 13.04 367.48 12.13 364.51 10.11 367.48 9.36 365.23 8.83 363.62 7 364.81 7.91 369.57 2.96 365.1 1.86 367.19 -0.52 364.21 -0.52 387.51 500.59 387.51 500.59 373.85",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "491.05 383.33 488.61 372.78 485.03 377.85 478.98 372.49 475.87 377.55 474.22 373.98 472.39 376.66 470 373.38 466.71 377.25 465.06 373.38 462.86 377.85 457.73 375.47 456.08 377.25 451.31 374.57 448.2 374.57 446.37 376.66 444.72 373.98 443.43 376.36 441.05 372.49 438.85 375.76 436.65 372.19 432.07 376.06 429.87 371.6 428.41 374.87 427.13 373.09 422.36 373.68 421.81 371.6 418.88 374.28 418.33 370.11 416.68 372.79 413.38 370.41 412.83 372.79 408.98 368.03 406.6 373.38 403.3 367.43 401.65 373.68 397.99 370.71 395.79 373.98 394.87 371.6 392.86 374.57 391.21 370.41 388.46 373.98 387.55 371 387.18 373.38 384.8 371.3 383.7 373.68 381.68 370.11 380.58 372.49 378.93 370.11 377.83 372.19 376.55 371.9 375.27 373.38 373.99 370.71 372.52 373.38 370.5 370.11 368.12 373.98 363.36 369.52 362.62 373.09 360.42 370.41 357.31 374.57 356.39 371 353.83 374.57 352.91 371 351.26 374.87 349.61 370.11 348.51 373.68 346.13 370.11 345.58 374.87 344.12 375.17 343.2 372.19 341.18 375.17 340.44 372.92 339.9 371.3 338.07 372.49 338.99 377.25 334.04 372.79 332.94 374.87 330.56 371.9 330.56 373.1 330.39 372.78 325.51 383.33 323.08 372.78 319.5 377.85 313.45 372.49 310.33 377.55 308.68 373.98 306.85 376.66 304.47 373.38 301.17 377.25 299.52 373.38 297.32 377.85 292.19 375.47 290.54 377.25 285.78 374.57 282.66 374.57 280.83 376.66 279.18 373.98 277.9 376.36 275.52 372.49 273.32 375.76 271.12 372.19 266.54 376.06 264.34 371.6 262.87 374.87 261.59 373.09 256.82 373.68 256.27 371.6 253.34 374.28 252.79 370.11 251.14 372.79 247.85 370.41 247.3 372.79 243.45 368.03 241.07 373.38 237.77 367.43 236.12 373.68 232.45 370.71 230.25 373.98 229.34 371.6 227.32 374.57 225.67 370.41 222.93 373.98 222.01 371 221.64 373.38 219.26 371.3 218.16 373.68 216.15 370.11 215.04 372.49 213.4 370.11 212.3 372.19 211.01 371.9 209.73 373.38 208.45 370.71 206.98 373.38 204.97 370.11 202.59 373.98 197.82 369.52 197.09 373.09 194.89 370.41 191.77 374.57 190.86 371 188.29 374.57 187.38 371 185.73 374.87 184.08 370.11 182.98 373.68 180.59 370.11 180.04 374.87 178.58 375.17 177.66 372.19 175.65 375.17 174.9 372.92 174.37 371.3 172.53 372.49 173.45 377.25 168.5 372.79 167.4 374.87 165.02 371.9 165.02 373.1 164.85 372.78 159.98 383.33 157.54 372.78 153.96 377.85 147.91 372.49 144.8 377.55 143.15 373.98 141.31 376.66 138.93 373.38 135.63 377.25 133.99 373.38 131.79 377.85 126.66 375.47 125.01 377.25 120.24 374.57 117.13 374.57 115.29 376.66 113.64 373.98 112.36 376.36 109.98 372.49 107.78 375.76 105.58 372.19 101 376.06 98.8 371.6 97.34 374.87 96.05 373.09 91.29 373.68 90.74 371.6 87.81 374.28 87.26 370.11 85.61 372.79 82.31 370.41 81.76 372.79 77.91 368.03 75.53 373.38 72.23 367.43 70.58 373.68 66.92 370.71 64.72 373.98 63.8 371.6 61.79 374.57 60.14 370.41 57.39 373.98 56.47 371 56.11 373.38 53.72 371.3 52.62 373.68 50.61 370.11 49.51 372.49 47.86 370.11 46.76 372.19 45.48 371.9 44.2 373.38 42.91 370.71 41.45 373.38 39.43 370.11 37.05 373.98 32.28 369.52 31.55 373.09 29.35 370.41 26.24 374.57 25.32 371 22.75 374.57 21.84 371 20.19 374.87 18.54 370.11 17.44 373.68 15.06 370.11 14.51 374.87 13.04 375.17 12.13 372.19 10.11 375.17 9.36 372.92 8.83 371.3 7 372.49 7.91 377.25 2.96 372.79 1.86 374.87 -0.52 371.9 -0.52 387.51 500.59 387.51 500.59 381.53 495.92 372.78 491.05 383.33",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.09,198.06l-1.9-.81-3.79-.54a9,9,0,0,0-5.42-2.17c-3.53-.27-2.44,1.08-2.44,1.08a13.21,13.21,0,0,0-3.8-1.08,28.71,28.71,0,0,0-3.25.27l-4.87-2.17c-4.88-2.17-9.76,2.17-9.76,2.17l-.35.18a7.59,7.59,0,0,0-2.15-.45,28.71,28.71,0,0,0-3.25.27l-4.88-2.17c-4.87-2.17-9.75,2.17-9.75,2.17L294,197.14l-4.51-2.33s-4.88-4.34-9.76-2.17l-4.88,2.17a28.45,28.45,0,0,0-3.25-.27,13.22,13.22,0,0,0-3.79,1.08s1.08-1.35-2.44-1.08a9,9,0,0,0-5.42,2.17l-3.79.54-1.9.81-7.31.81H361.4Z",
    style: {
      fill: "#737373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.38,225.22s4.73-4.21,9.47-2.11l4.74,2.11a28,28,0,0,1,3.15-.26,12.82,12.82,0,0,1,3.69,1s-1.05-1.32,2.37-1a8.74,8.74,0,0,1,5.26,2.1l3.68.53,1.84.79,7.11.79H444.75Z",
    style: {
      fill: "#737373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494,185.23l-1.9-.81-3.79-.54a9,9,0,0,0-5.42-2.17c-3.52-.27-2.44,1.08-2.44,1.08a13.22,13.22,0,0,0-3.79-1.08,28.73,28.73,0,0,0-3.26.27l-4.87-2.17c-4.88-2.16-9.76,2.17-9.76,2.17l-.35.18a8,8,0,0,0-2.15-.45A28.71,28.71,0,0,0,453,182l-4.87-2.17c-4.88-2.16-9.76,2.17-9.76,2.17l-4.51,2.33L429.33,182s-4.88-4.33-9.76-2.17L414.7,182a28.73,28.73,0,0,0-3.26-.27,13.22,13.22,0,0,0-3.79,1.08s1.08-1.35-2.44-1.08a9,9,0,0,0-5.42,2.17l-3.79.54-1.9.81-7.31.81H501.27Z",
    style: {
      fill: "#737373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.41,185.23l-1.89-.81-3.8-.54a9,9,0,0,0-5.41-2.17c-3.53-.27-2.44,1.08-2.44,1.08a13.21,13.21,0,0,0-3.8-1.08,28.71,28.71,0,0,0-3.25.27L255,179.81c-4.88-2.16-9.76,2.17-9.76,2.17l-.35.18a8,8,0,0,0-2.15-.45,28.71,28.71,0,0,0-3.25.27l-4.88-2.17c-4.87-2.16-9.75,2.17-9.75,2.17l-4.51,2.33L215.78,182s-4.87-4.33-9.75-2.17L201.15,182a28.45,28.45,0,0,0-3.25-.27,13.22,13.22,0,0,0-3.79,1.08s1.08-1.35-2.44-1.08a9,9,0,0,0-5.42,2.17l-3.79.54-1.9.81-7.31.81H287.73Z",
    style: {
      fill: "#737373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.05,185.23l-1.9-.81-3.79-.54a9,9,0,0,0-5.42-2.17c-3.52-.27-2.44,1.08-2.44,1.08a13.22,13.22,0,0,0-3.79-1.08,28.45,28.45,0,0,0-3.25.27l-4.88-2.17c-4.88-2.16-9.75,2.17-9.75,2.17l-.36.18a8,8,0,0,0-2.14-.45,28.73,28.73,0,0,0-3.26.27l-4.87-2.17c-4.88-2.16-9.76,2.17-9.76,2.17l-4.51,2.33L318.42,182s-4.88-4.33-9.76-2.17L303.79,182a28.71,28.71,0,0,0-3.25-.27,13.21,13.21,0,0,0-3.8,1.08s1.09-1.35-2.44-1.08a9,9,0,0,0-5.41,2.17l-3.8.54-1.89.81-7.32.81H390.36Z",
    style: {
      fill: "#737373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.14,225.22s4.74-4.21,9.47-2.11l4.74,2.11a28,28,0,0,1,3.16-.26,12.83,12.83,0,0,1,3.68,1s-1.05-1.32,2.37-1a8.74,8.74,0,0,1,5.26,2.1l3.69.53,1.84.79,7.1.79H280.51Z",
    style: {
      fill: "#737373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.34,200.34s3-2.62,5.9-1.31l2.95,1.31a17.74,17.74,0,0,1,2-.16,8,8,0,0,1,2.29.65s-.65-.82,1.48-.65a5.44,5.44,0,0,1,3.28,1.31l2.29.33,1.15.49,4.42.49H436.59Z",
    style: {
      fill: "#737373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.78,440.15s5.28-4.69,10.56-2.34l5.28,2.34a31.4,31.4,0,0,1,3.52-.29,14.28,14.28,0,0,1,4.11,1.17s-1.17-1.46,2.64-1.17a9.72,9.72,0,0,1,5.87,2.35l4.11.58,2.05.88,7.92.89H437.27Z",
    style: {
      fill: "#737373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.84,478.65s5.28-4.7,10.56-2.35l5.28,2.35a31.14,31.14,0,0,1,3.52-.29,14.28,14.28,0,0,1,4.11,1.17s-1.17-1.47,2.64-1.17a9.79,9.79,0,0,1,5.87,2.34l4.11.59,2.05.88,7.92.88H275.33Z",
    style: {
      fill: "#737373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.26,350.75s5.28-4.69,10.57-2.34l5.28,2.34a31.14,31.14,0,0,1,3.52-.29,14.28,14.28,0,0,1,4.11,1.17s-1.18-1.46,2.64-1.17a9.76,9.76,0,0,1,5.87,2.35l4.1.58,2.06.89,7.92.88H270.75Z",
    style: {
      fill: "#737373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.79,350.75s5.28-4.69,10.56-2.34l5.28,2.34a31.43,31.43,0,0,1,3.53-.29,14.29,14.29,0,0,1,4.1,1.17s-1.17-1.46,2.64-1.17a9.72,9.72,0,0,1,5.87,2.35l4.11.58,2.06.89,7.92.88H207.28Z",
    style: {
      fill: "#737373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,403.48s5.28-4.69,10.57-2.35l5.28,2.35a31.14,31.14,0,0,1,3.52-.29,14.28,14.28,0,0,1,4.11,1.17s-1.18-1.47,2.64-1.17a9.79,9.79,0,0,1,5.87,2.34l4.1.59,2.06.88,7.92.88H258.45Z",
    style: {
      fill: "#737373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.7,407l-2.05-.88-4.11-.59a9.75,9.75,0,0,0-5.87-2.34c-3.81-.3-2.64,1.17-2.64,1.17a14.29,14.29,0,0,0-4.1-1.17,31.43,31.43,0,0,0-3.53.29l-5.28-2.35c-5.28-2.34-10.56,2.35-10.56,2.35l-1.71.89a10.48,10.48,0,0,0-4.16-1.18c-3.81-.3-2.64,1.17-2.64,1.17a14.28,14.28,0,0,0-4.11-1.17,31.14,31.14,0,0,0-3.52.29l-5.28-2.35c-5.28-2.34-10.56,2.35-10.56,2.35l-8.51,4.4h86.56Z",
    style: {
      fill: "#737373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.08,296.59s6.38-5.67,12.76-2.83l6.38,2.83a37.77,37.77,0,0,1,4.26-.35,17.2,17.2,0,0,1,5,1.42s-1.42-1.78,3.19-1.42a11.78,11.78,0,0,1,7.09,2.83l5,.71,2.49,1.07,9.57,1.06H430.79Z",
    style: {
      fill: "#737373"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-42"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "359.74 197.32 355.79 232.93 384.2 232.93 381.44 197.81 372.66 194.06 359.74 197.32",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.52 229.97 362.6 226.13 391.5 226.13 397.13 230.27 397.13 250.45 394.46 250.45 394.46 262.92 356.29 262.92 356.29 250.4 353.41 250.4 353.52 229.97",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.08,164s-8.25,2.62-9.51,5-3.14,21.62-3.14,21.62l-1.38,6.91s9.67,3,10.64,3h1l2.71-1.65,1.17,1.17s3.49-1.17,4.37-1.36l3.39-.78-2.23-7.57,2.23-7.47s3.11-3.59,4.27-5.05,3.49-4.27,3.49-4.27a18.9,18.9,0,0,0-2.62-5.53C385.7,165.69,376,163,373.08,164Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.71,163s-2.21.61-2.69,1.58-3.21,10.19-3.21,10.19l7.18-1.85,4.66,4.08,1.94-5.24s0-4.08-2.33-6.21S376,162.15,374.71,163Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.71,163s-.56.71-.17,1.19l.39.49a12.08,12.08,0,0,0-1.17,3.49c-.19,1.65-.48,4,.2,5.34a24.59,24.59,0,0,0,2.23,3.3l4-4.76a8.77,8.77,0,0,0,2.42-.29,10.63,10.63,0,0,0,3.11-3.4,19.11,19.11,0,0,0,.77-3.68l-11.83-2.92Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.93 163.34 385.96 165.37 387.18 163.41 373.55 161.94 374.93 163.34",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.38,167.63a5.65,5.65,0,0,0,3.79,4.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "384.73 165.6 384.24 168.41 382.98 168.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 381.33,
    y1: 169.57,
    x2: 382.69,
    y2: 169.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.84,159.52l-3.95.27s2.37,2.9,3.82,3.16l7.25,1.32s4.75,2.24,7.25,1.84a6.12,6.12,0,0,0,3.82-2.24l-3.95-1.45-.92.13Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.42,155.7l-1.58,3.82s7.78,3.17,10.15,3.3a7.19,7.19,0,0,0,3.17-.27s.92-5.66.26-6.59-4.09-2.24-7.12-2.11S377.08,153.85,376.42,155.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.06,173.55l2.24,8.74s5,9.51,4.95,10.09a11.88,11.88,0,0,1-.59,1.75s-2.62,0-2.91.29-2.33-.68-4.46-2.91a33,33,0,0,1-4.27-5.83,3.69,3.69,0,0,0-1.36-1.55,9.16,9.16,0,0,1-1.36-1.26Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.45,166.18s-4.56.39-5.82,1.75-3.2,6.79-4.66,10.38-3.68,9-3.2,11.06,1.75,6.21,1.75,6.21,3.1,1.75,3.69,1.07a13,13,0,0,0,1.45-2.72c.1-.29,2-5.14,3.5-8.25s3.2-7.66,3.29-10.09",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,195.64s-1.74-2-3.18-1.82-1.74,2.42-1.74,2.65-1.36,3.25-1.29,4.09,2.35,1.81,2.73,1.74,1.66.07,1.74-1.14a5.36,5.36,0,0,1,.23-1.89c.15-.3.83-.23,1.06-.83A21.65,21.65,0,0,0,360,195.64Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.18,194.05,398,195a9.59,9.59,0,0,1,2.88.75,4.57,4.57,0,0,1,1.13,2.73,1.71,1.71,0,0,1-1.82,1.59,12.21,12.21,0,0,1-2.49-.91c-.76-.23-1.37,0-1.9-.61a19.87,19.87,0,0,1-1.51-1.89c-.23-.38-1.14-2.19-1.14-2.19S395.58,193.52,396.18,194.05Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.61,198.09l1.92-5.63a2.71,2.71,0,0,1,2.62-1.86L391,191a13.9,13.9,0,0,1,1.58,2.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.31,208s-11.58-12.26-12-12.34-1.73,0-2,.45A15.84,15.84,0,0,0,356,200a1,1,0,0,0,1.13.15,10.67,10.67,0,0,0,1.13-1.57l7.91,9.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.69,197.19s-.82-1.58-1.8-1.65a6.61,6.61,0,0,0-2,.22l-15.12,12.11,4,3.91,11.44-13.91,2.54,1.25Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.69,197.19s-1.12-.37-1.43.6a2.72,2.72,0,0,0,0,2.41c.46.83,1.81,2.18,1.88,3.69s-.15,3.53.38,3.68,1.05-1.88.9-3.16-2.18-4.59-2-4.89S399.6,198.32,398.69,197.19Z",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.59 214.42 345.59 217.2 409.22 217.2 409.22 214.27 345.59 214.42",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.71,
    y: 208.01,
    width: 18.92,
    height: 14.06,
    rx: 1.5,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.86,
    y: 202.61,
    width: 8.8,
    height: 5.34,
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.3,198.55s.45-1.58-.6-1.21-1,2.92-1.18,5-1.38,4.75-1.3,6.32.52,2.11.75,1.43,2.18-5.71,2.48-6.84A20.92,20.92,0,0,0,358.3,198.55Z",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.33,
    y: 215.24,
    width: 3.23,
    height: 27.08,
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.31,
    y: 207.5,
    width: 2.11,
    height: 15.8,
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.42 207.5 390.42 223.29 394.41 216.37 394.41 214.27 390.42 207.5",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.46,
    y: 223.37,
    width: 4.23,
    height: 19.03,
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.44,
    y: 221.86,
    width: 21.89,
    height: 20.46,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.68,
    y: 225.1,
    width: 10.91,
    height: 12.56,
    rx: 1.66,
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.88 237.43 365.6 242.1 367.78 245.63 380.12 245.63 382.45 242.25 378.38 237.73 369.88 237.43",
    style: {
      fill: "#e0e0e0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.6 242.1 360.18 245.33 353.41 245.26 353.41 250.15 363.57 250.15 370.71 255.56 377.48 255.56 385.91 250.45 396.66 250.45 396.66 245.1 387.86 245.1 382.45 242.25 380.12 245.63 367.78 245.63 365.6 242.1",
    style: {
      fill: "#c9c9c9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.21 229.69 398.92 224.5 398.92 228.63 430.06 234.65 430.21 229.69",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.22 234.2 430.21 242.7 430.21 236.91 398.92 228.63 399.22 234.2",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.07 241.65 430.21 253.15 430.21 247.44 399.14 237.13 399.07 241.65",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.07 251.27 430.21 261.8 430.21 257.97 398.92 247.59 399.07 251.27",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.71,
    y: 230.51,
    width: 1.35,
    height: 32.64,
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.19,
    y: 224.5,
    width: 1.58,
    height: 38.81,
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.21,
    y: 224.5,
    width: 1.58,
    height: 38.81,
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.92 229.69 430.21 224.5 430.21 228.63 399.07 234.65 398.92 229.69",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.21 228.63 398.92 236.91 398.92 242.7 429.91 234.2 430.21 228.63",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.98 237.13 398.92 247.44 398.92 253.15 430.06 241.65 429.98 237.13",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.21 247.59 398.92 257.97 398.92 261.8 430.06 251.27 430.21 247.59",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.54 229.69 351.83 224.5 351.83 228.63 320.69 234.65 320.54 229.69",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.53 234.2 320.54 242.7 320.54 236.91 351.83 228.63 351.53 234.2",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.68 241.65 320.54 253.15 320.54 247.44 351.6 237.13 351.68 241.65",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.68 251.27 320.54 261.8 320.54 257.97 351.83 247.59 351.68 251.27",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.68,
    y: 230.51,
    width: 1.35,
    height: 32.64,
    transform: "translate(670.71 493.67) rotate(180)",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.98,
    y: 224.5,
    width: 1.58,
    height: 38.81,
    transform: "translate(705.53 487.8) rotate(180)",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.96,
    y: 224.5,
    width: 1.58,
    height: 38.81,
    transform: "translate(639.49 487.8) rotate(180)",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.83 229.69 320.54 224.5 320.54 228.63 351.68 234.65 351.83 229.69",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.54 228.63 351.83 236.91 351.83 242.7 320.84 234.2 320.54 228.63",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.76 237.13 351.83 247.44 351.83 253.15 320.69 241.65 320.76 237.13",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.54 247.59 351.83 257.97 351.83 261.8 320.69 251.27 320.54 247.59",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.69,265.21l-3.32-1.42-6.65-1a15.8,15.8,0,0,0-9.51-3.8c-6.18-.48-4.27,1.9-4.27,1.9s-4.28-1.9-6.66-1.9a50.66,50.66,0,0,0-5.7.47l-8.55-3.8c-8.55-3.8-17.11,3.8-17.11,3.8l-.62.32a13.4,13.4,0,0,0-3.76-.79,50.4,50.4,0,0,0-5.7.47l-8.56-3.8c-8.55-3.8-17.1,3.8-17.1,3.8l-7.92,4.09-7.91-4.09s-8.55-7.6-17.1-3.8l-8.56,3.8A50.4,50.4,0,0,0,328,259c-2.37,0-6.65,1.9-6.65,1.9s1.9-2.38-4.28-1.9a15.79,15.79,0,0,0-9.5,3.8l-6.65,1-3.33,1.42-12.83,1.43H485.52Z",
    style: {
      fill: "#737373"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.61,333.36s-1.09,9.7-1,10.11,16.66,0,16.66,0-3.41-2.32-4.92-3.55-4.37-1.91-4.64-2.73-1.5-3.83-1.5-3.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.92 331.77 72.37 336 67.46 343.92 77.56 343.92 77.02 335.45 77.56 331.77 72.92 331.77",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.79 250.94 74.28 296.54 71.01 332.18 80.56 332.59 89.99 297.36 96.81 266.37 103.64 299.55 108.56 334.87 121.12 335.41 117.84 304.73 116.61 254.35 75.79 250.94",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.27,183.21s-10.46,3.2-11.23,5.33-1.45,33.3-1.45,33.3l-5.33,29s9.49,6.2,15,7.26l8.52,1.65.67-4.17L100,259.5s12.39-1.84,14-2.52a17.63,17.63,0,0,1,3.39-1l-2.13-38.63.67-9.29s1.17-20-.09-20.72-12.49-4.16-12.49-4.16Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.88,180.79l-1.74,9.68,11.52-3.39,7.07,2.81a71.41,71.41,0,0,0-2.62-7.26,7,7,0,0,0-1.93-2.13Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.59 184.18 99.69 195.99 103.66 184.86 103.66 182.05 92.91 181.86 93.59 184.18",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.33,168s1.74,8.14,2.91,10.17,3.58,6.39,6.67,7.06a6.64,6.64,0,0,0,6.68-2.61,20.75,20.75,0,0,0,2.72-5.23c.38-1.55,1.74-6.58,1.74-6.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.63 172.66 102.59 182.63 113.53 173.14 110.63 172.66",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.17 168.21 89.72 179.44 82.85 168.88 79.17 168.21",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4,174.4s.87,2,.19,2.71-2.8.58-2.9-.19a15.49,15.49,0,0,1,0-2.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.82,180.11s2.9.88,4.16,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.72,172.66a4.46,4.46,0,0,0,3.1.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.14,173.43a3.22,3.22,0,0,0,2.52.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.04 169.85 88.17 174.69 85.46 169.18 95.04 169.85",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.95 171.89 105.31 177.4 110.63 172.66 103.95 171.89",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.36 147.86 72 167.06 121.21 174.06 100.36 147.86",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.86,187.37s1.74-.38,5.13,5.43,6.29,16,8.23,19.84,2.9,7.94,2.13,9.49a34.14,34.14,0,0,1-2.23,3.58s-2.32,3.39-3.29,4.45-2,4-3.39,3.49-5-4.07-4.36-5.13,2.33-2,2.42-2.33-.58-1-.19-2.42.68-2.8.68-2.8-2.81-1.75-2.91-3.39-2.13-9.49-2.13-9.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.44,233.65s-1.16-3.68-2.23-4.84-1.26-1.26-2.13-.29A30.36,30.36,0,0,0,114.5,234c-.48,1.25,2.91,2.51,4.16,3.38s2.42,1.75,2.42,1.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.82,231.81l-3.1-4.45,3.3,1.45-3.49-7,4.45,4.94-.48-5.14,3.48,6.3.2-6,2.52,8.33,1-6.49,1.55,5.13L114.5,234l6.58,5.13s8.23,5.22,8.52,5.8.29,1.26-.38,1.36-1.55-.87-1.26-.1a14.92,14.92,0,0,1,.77,2.23,16,16,0,0,1,0,2.23l-1.26-.49.1,4.07s-1.35,1.93-1.84,1.84-1.45-1.84-1.45-1.84v3.87l-.87,1.07s-2.23-.2-2.42-1a3.66,3.66,0,0,0-.58-1.26l-1.16,2.52-2.62.58-2.13-2.33-1.35,2.71-1.26.49-1.36-2.42v-.87l-1.45,1.84s-1.84.77-1.94.19-.38-3.29-.38-3.29l-1.36.58s-1.35.1-1.35-.39a4.09,4.09,0,0,1,.19-1.06l-1.65.19,6.88-12.87.58-2.23Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.28,258.14v-3.87s1,1.74,1.45,1.84,1.84-1.84,1.84-1.84l-.1-4.07,1.26.49a16,16,0,0,0,0-2.23,14.92,14.92,0,0,0-.77-2.23c-.29-.77.58.2,1.26.1s.67-.77.38-1.36a36,36,0,0,0-4.35-3.11l.29.79-.39,3.58-3.1-2.32.2,5.32a23.8,23.8,0,0,0-2.81-3.09s-1,4.84-1,5.51-3-3.29-3-3.29l-.87,2.42-2.42-2.71-2,2.33L109,246.14,105.69,250l0,0-3.08,5.76,1.65-.19a4.09,4.09,0,0,0-.19,1.06c0,.49,1.35.39,1.35.39l1.36-.58s.29,2.71.38,3.29,1.94-.19,1.94-.19l1.45-1.84v.87l1.36,2.42,1.26-.49,1.35-2.71,2.13,2.33,2.62-.58,1.16-2.52a3.66,3.66,0,0,1,.58,1.26c.19.77,2.42,1,2.42,1Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.46,185.54s-4.26-.1-6.29,1.35a15.29,15.29,0,0,0-5.91,9.78c-.58,4.64.49,17.91,2.81,21.3s7.07,6.48,10.55,9,1.36,2.32,3.78,3.48a11.74,11.74,0,0,0,4,1.26s2,1.26,2.71,1.55,1.74.49,3.09-.87,2.72-2.9,1.94-4-4-3-4-3a9,9,0,0,0-1.55-3c-1.06-1.26-6.29-5.81-7.06-6.68a16.64,16.64,0,0,1-1.94-3.49c-.1-.29-.29-4.35-.87-6.87s-.87-3.58-.87-3.58.48-1.84.77-3.58a25.67,25.67,0,0,0,.29-3.88",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.08,229.49l4.74,2.32,5.23,1.26a35,35,0,0,1,2.23,4.64,14.69,14.69,0,0,1-1.17,2.91,49.83,49.83,0,0,1-5.61.1c-1-.2-1.55-.68-1.45-1.26a8.84,8.84,0,0,0-.1-1.84,5.34,5.34,0,0,1-3.29-.58,14.5,14.5,0,0,1-2.52-3l-2.22-1.65S99.4,228,103.08,229.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--rice-2--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.19,335.82l-18-33.73,3.33,3.83-.37-5.71,4.45,6.54.18-7.23,2,4.85,2.4-10.35,2,12.82,2.59-9.26s3.52,9.94,3.52,9.2,4.63-13.1,4.63-13.1v10l3.15-3.36v6.85l3-6.32v8l4.26-6.41-.93,4.88,4.45-4.76-3.34,10.42,5-5.91L174,335l13.33,19.25-3.89-1,.56,3.47-3.89-2.87-.74,4.5L177.19,356l-1.67,1-2.59-3-3,3.54-.93-2-.92,1.92-2-1.89-1.85-.24-2.22-.4-3.71,1.74-.74-2.54-1.48.84-1.67-1.73-2,1.44-1.48-.45Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.41 339.9 167.19 335.82 164.22 339.19 164.41 339.9",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.37 327.32 177 323.65 174.97 327.31 173.85 324.24 172.66 327.15 172.37 327.86 171.82 319.38 168.86 326.07 168.67 319.79 167 325.65 164.97 322.27 164.97 327.27 161.63 324.54 161.66 325.44 167.19 335.82 167.75 338.93 169.41 337.7 169.41 342.88 171.63 339.58 174.59 342.15 173.48 337.6 176.45 340.16 177.55 340.03 174.04 334.96 177.64 328.5 177.37 327.32",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.33,335.82l-18-33.73,3.33,3.83-.37-5.71,4.44,6.54.19-7.23,2,4.85L195.4,294l2,12.82,2.59-9.26s3.52,9.94,3.52,9.2,4.63-13.1,4.63-13.1v10l3.14-3.36v6.85l3-6.32v8l4.25-6.41-.92,4.88,4.44-4.76-3.33,10.42,5-5.91L208.18,335l13.33,19.25-3.89-1,.55,3.47-3.88-2.87-.74,4.5L211.32,356l-1.66,1-2.59-3-3,3.54-.92-2-.93,1.92-2-1.89-1.85-.24-2.22-.4-3.7,1.74-.74-2.54-1.48.84-1.67-1.73-2,1.44-1.48-.45Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.55 339.9 201.33 335.82 198.36 339.19 198.55 339.9",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.51 327.32 211.14 323.65 209.1 327.31 207.99 324.24 206.8 327.15 206.51 327.86 205.96 319.38 202.99 326.07 202.81 319.79 201.14 325.65 199.1 322.27 199.1 327.27 195.77 324.54 195.8 325.44 201.33 335.82 201.88 338.93 203.55 337.7 203.55 342.88 205.77 339.58 208.73 342.15 207.62 337.6 210.58 340.16 211.69 340.03 208.18 334.96 211.78 328.5 211.51 327.32",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.74,316.65l-18-33.73,3.34,3.84L16.75,281l4.44,6.54.19-7.23,2,4.85,2.41-10.35,2,12.82,2.59-9.26s3.52,9.94,3.52,9.2,4.62-13.1,4.62-13.1v10l3.15-3.37V288l3-6.32v8L49,283.22,48,288.1l4.44-4.75-3.33,10.41,5-5.9L38.59,315.8,51.93,335,48,334l.55,3.48-3.89-2.88-.74,4.5-2.22-2.25-1.66,1-2.6-3-3,3.54-.92-2-.93,1.91-2-1.89-1.85-.24-2.22-.4-3.7,1.74-.74-2.54-1.48.85L19,334.21l-2,1.44-1.48-.45Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28.97 320.73 31.74 316.65 28.78 320.03 28.97 320.73",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.93 308.16 41.56 304.48 39.52 308.14 38.41 305.07 37.22 307.99 36.93 308.69 36.37 300.22 33.41 306.9 33.23 300.62 31.56 306.48 29.52 303.11 29.52 308.1 26.19 305.38 26.22 306.27 31.74 316.65 32.3 319.76 33.97 318.53 33.97 323.71 36.19 320.41 39.15 322.98 38.04 318.43 41 321 42.1 320.87 38.59 315.8 42.19 309.33 41.93 308.16",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.17,335.82l-18-33.73,3.33,3.83-.37-5.71,4.45,6.54.18-7.23,2,4.85L36.25,294l2,12.82,2.59-9.26s3.52,9.94,3.52,9.2S49,293.68,49,293.68v10l3.15-3.36v6.85l3-6.32v8l4.26-6.41-.93,4.88,4.45-4.76-3.34,10.42,5-5.91L49,335l13.33,19.25-3.89-1,.56,3.47-3.89-2.87-.74,4.5L52.17,356l-1.67,1-2.59-3-3,3.54-.93-2-.92,1.92-2-1.89-1.85-.24-2.22-.4-3.71,1.74-.74-2.54-1.48.84-1.67-1.73-2,1.44-1.48-.45Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.39 339.9 42.17 335.82 39.2 339.19 39.39 339.9",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.35 327.32 51.98 323.65 49.95 327.31 48.84 324.24 47.64 327.15 47.35 327.86 46.8 319.38 43.84 326.07 43.65 319.79 41.98 325.65 39.95 322.27 39.95 327.27 36.62 324.54 36.64 325.44 42.17 335.82 42.73 338.93 44.39 337.7 44.39 342.88 46.61 339.58 49.58 342.15 48.47 337.6 51.43 340.16 52.53 340.03 49.02 334.96 52.62 328.5 52.35 327.32",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.74,318.52,57.79,284.79l3.33,3.84-.37-5.72,4.44,6.54.19-7.23,2,4.85,2.41-10.35,2,12.82,2.59-9.26s3.52,9.94,3.52,9.2,4.63-13.1,4.63-13.1v10L85.74,283v6.85l3-6.32v8L93,285.09,92,290l4.44-4.75-3.33,10.41,5-5.9L82.6,317.67l13.33,19.24-3.89-1,.55,3.48-3.88-2.88L88,341l-2.22-2.25-1.66,1-2.6-3-3,3.54-.92-2-.93,1.91-2-1.89-1.85-.24-2.22-.4-3.7,1.74L66.12,337l-1.48.85L63,336.08l-2,1.44-1.48-.45Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.97 322.6 75.75 318.52 72.78 321.9 72.97 322.6",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.93 310.03 85.56 306.35 83.52 310.01 82.41 306.94 81.22 309.86 80.93 310.56 80.37 302.09 77.41 308.77 77.23 302.49 75.56 308.35 73.52 304.97 73.52 309.97 70.19 307.25 70.22 308.14 75.75 318.52 76.3 321.63 77.97 320.4 77.97 325.58 80.19 322.28 83.15 324.85 82.04 320.3 85 322.87 86.11 322.74 82.59 317.67 86.19 311.2 85.93 310.03",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.73,318.52l-18-33.73,3.34,3.84-.37-5.72,4.44,6.54.18-7.23,2,4.85,2.41-10.35,2,12.82,2.59-9.26s3.52,9.94,3.52,9.2,4.62-13.1,4.62-13.1v10l3.15-3.37v6.85l3-6.32v8l4.26-6.41L137,290l4.44-4.75-3.33,10.41,5-5.9-15.56,27.94,13.33,19.24-3.88-1,.55,3.48-3.89-2.88L133,341l-2.22-2.25-1.66,1-2.6-3-3,3.54-.93-2-.92,1.91-2-1.89-1.85-.24-2.22-.4-3.7,1.74-.74-2.54-1.49.85L108,336.08l-2,1.44-1.48-.45Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.96 322.6 120.73 318.52 117.77 321.9 117.96 322.6",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.92 310.03 130.55 306.35 128.51 310.01 127.4 306.94 126.21 309.86 125.92 310.56 125.36 302.09 122.4 308.77 122.22 302.49 120.55 308.35 118.51 304.97 118.51 309.97 115.18 307.25 115.21 308.14 120.73 318.52 121.29 321.63 122.95 320.4 122.95 325.58 125.18 322.28 128.14 324.85 127.03 320.3 129.99 322.87 131.09 322.74 127.58 317.67 131.18 311.2 130.92 310.03",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,335.82l-18-33.73,3.33,3.83L77,300.21l4.44,6.54.19-7.23,2,4.85L86.11,294l2,12.82,2.59-9.26s3.52,9.94,3.52,9.2,4.63-13.1,4.63-13.1v10l3.15-3.36v6.85l3-6.32v8l4.26-6.41-.93,4.88,4.44-4.76-3.33,10.42,5-5.91L98.89,335l13.33,19.25-3.89-1,.56,3.47L105,353.79l-.74,4.5L102,356l-1.67,1-2.59-3-3,3.54-.93-2L93,357.6l-2-1.89-1.85-.24-2.23-.4-3.7,1.74-.74-2.54-1.48.84-1.67-1.73-2,1.44-1.49-.45Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.26 339.9 92.04 335.82 89.07 339.19 89.26 339.9",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.22 327.32 101.85 323.65 99.81 327.31 98.7 324.24 97.51 327.15 97.22 327.86 96.67 319.38 93.7 326.07 93.52 319.79 91.85 325.65 89.82 322.27 89.82 327.27 86.48 324.54 86.51 325.44 92.04 335.82 92.59 338.93 94.26 337.7 94.26 342.88 96.48 339.58 99.44 342.15 98.33 337.6 101.3 340.16 102.4 340.03 98.89 334.96 102.49 328.5 102.22 327.32",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.73,335.82l-18-33.73,3.34,3.83-.37-5.71,4.44,6.54.19-7.23,2,4.85L128.81,294l2,12.82,2.59-9.26s3.52,9.94,3.52,9.2,4.63-13.1,4.63-13.1v10l3.14-3.36v6.85l3-6.32v8l4.26-6.41-.92,4.88,4.44-4.76-3.33,10.42,5-5.91L141.59,335l13.33,19.25-3.89-1,.55,3.47-3.89-2.87-.74,4.5L144.73,356l-1.66,1-2.6-3-3,3.54-.92-2-.93,1.92-2-1.89-1.85-.24-2.22-.4-3.7,1.74-.74-2.54-1.48.84L122,353.38l-2,1.44-1.48-.45Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.96 339.9 134.73 335.82 131.77 339.19 131.96 339.9",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.92 327.32 144.55 323.65 142.51 327.31 141.4 324.24 140.21 327.15 139.92 327.86 139.36 319.38 136.4 326.07 136.22 319.79 134.55 325.65 132.51 322.27 132.51 327.27 129.18 324.54 129.21 325.44 134.73 335.82 135.29 338.93 136.96 337.7 136.96 342.88 139.18 339.58 142.14 342.15 141.03 337.6 143.99 340.16 145.09 340.03 141.59 334.96 145.18 328.5 144.92 327.32",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.58,335.82l-18-33.73L54,305.92l-.37-5.71L58,306.75l.19-7.23,2,4.85L62.65,294l2,12.82,2.59-9.26s3.52,9.94,3.52,9.2,4.63-13.1,4.63-13.1v10l3.15-3.36v6.85l3-6.32v8l4.26-6.41-.93,4.88,4.45-4.76L86,312.93,91,307,75.43,335l13.33,19.25-3.89-1,.56,3.47-3.89-2.87-.74,4.5L78.58,356l-1.67,1-2.59-3-3,3.54-.93-2-.93,1.92-2-1.89-1.85-.24-2.23-.4-3.7,1.74L59,354.27l-1.48.84-1.67-1.73-2,1.44-1.48-.45Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.8 339.9 68.58 335.82 65.61 339.19 65.8 339.9",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.76 327.32 78.39 323.65 76.36 327.31 75.24 324.24 74.05 327.15 73.76 327.86 73.21 319.38 70.25 326.07 70.06 319.79 68.39 325.65 66.36 322.27 66.36 327.27 63.02 324.54 63.05 325.44 68.58 335.82 69.13 338.93 70.8 337.7 70.8 342.88 73.02 339.58 75.98 342.15 74.87 337.6 77.84 340.16 78.94 340.03 75.43 334.96 79.03 328.5 78.76 327.32",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.62,341.33l-18-33.73L98,311.44l-.37-5.71,4.45,6.54.18-7.24,2,4.86,2.4-10.35,2,12.81,2.59-9.25s3.52,9.93,3.52,9.19,4.63-13.1,4.63-13.1v10l3.15-3.37v6.85l3-6.32v8l4.26-6.41-.93,4.88,4.45-4.76L130,318.45l5-5.91-15.55,27.94,13.33,19.25-3.89-1,.56,3.48-3.89-2.87-.74,4.49-2.22-2.25L121,362.6l-2.59-3-3,3.54-.93-2-.92,1.92-2-1.9-1.85-.24-2.22-.4-3.71,1.75-.74-2.54-1.48.84-1.67-1.73-2,1.43-1.48-.45Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.84 345.42 112.62 341.33 109.65 344.71 109.84 345.42",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.8 332.84 122.43 329.17 120.4 332.83 119.28 329.76 118.09 332.67 117.8 333.38 117.25 324.9 114.29 331.59 114.1 325.31 112.44 331.16 110.4 327.79 110.4 332.79 107.06 330.06 107.09 330.96 112.62 341.33 113.17 344.44 114.84 343.21 114.84 348.4 117.06 345.1 120.03 347.66 118.92 343.11 121.88 345.68 122.98 345.55 119.47 340.48 123.07 334.02 122.8 332.84",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.19,335.82l-18-33.73,3.33,3.83-.37-5.71,4.44,6.54.19-7.23,2,4.85L13.26,294l2,12.82,2.59-9.26s3.52,9.94,3.52,9.2S26,293.68,26,293.68v10l3.15-3.36v6.85l3-6.32v8l4.26-6.41-.93,4.88,4.45-4.76-3.34,10.42,5-5.91L26,335l13.33,19.25-3.89-1,.56,3.47-3.89-2.87-.74,4.5L29.19,356l-1.67,1-2.59-3-3,3.54-.93-2-.93,1.92-2-1.89-1.85-.24-2.23-.4-3.7,1.74-.74-2.54-1.48.84-1.67-1.73-2,1.44-1.48-.45Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.41 339.9 19.19 335.82 16.22 339.19 16.41 339.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.37 327.32 29 323.65 26.96 327.31 25.85 324.24 24.66 327.15 24.37 327.86 23.82 319.38 20.86 326.07 20.67 319.79 19 325.65 16.97 322.27 16.97 327.27 13.63 324.54 13.66 325.44 19.19 335.82 19.74 338.93 21.41 337.7 21.41 342.88 23.63 339.58 26.59 342.15 25.48 337.6 28.45 340.16 29.55 340.03 26.04 334.96 29.64 328.5 29.37 327.32",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.35,465.1c0,1.73-5.56,3.13-12.41,3.13s-12.41-1.4-12.41-3.13,5.56-3.14,12.41-3.14S266.35,463.37,266.35,465.1Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.55,459.25c9.59,1,16.31,3.47,16.31,6.3s-6.13,5.05-15,6.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.48,471.58c-8.35-1.16-14-3.42-14-6,0-2.22,4.13-4.19,10.53-5.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.11,457.4c0,1.73-5.55,3.14-12.4,3.14s-12.41-1.41-12.41-3.14,5.55-3.13,12.41-3.13S347.11,455.67,347.11,457.4Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.32,451.56c9.58,1,16.31,3.47,16.31,6.3s-6.14,5.05-15,6.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.25,463.88c-8.36-1.15-14-3.41-14-6,0-2.22,4.14-4.19,10.54-5.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.28,468.55c0,1.73-5.55,3.13-12.41,3.13s-12.4-1.4-12.4-3.13,5.55-3.14,12.4-3.14S431.28,466.82,431.28,468.55Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.48,462.71c9.59,1,16.32,3.46,16.32,6.3s-6.14,5-15.05,6.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.42,475c-8.36-1.16-14-3.42-14-6,0-2.22,4.13-4.2,10.54-5.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.84 465.64 244.6 428.65 250.42 454.57 251.3 421.08 253.04 446.71 256.54 430.69 254.5 454.57 261.2 427.2 257.99 452.24 264.69 437.39 256.54 465.93 249.84 465.64",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.79,412l.89,45.33h11.94s1.76-17.91,2.87-21.89,5.31-23.22,5.31-23.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.51 430.97 411.81 469.22 425.96 469.22 426.4 431.19 404.51 430.97",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.16,373s-14.81,9.73-16.14,14.59-.44,26.53-.44,26.53l36.26,2.21,20.56-26.31s4.65,4.64,5.09,6,7.3,38.69,7.3,38.69l34.27-.66s-2.66-12.82-5.75-20.12-5.09-12.16-5.09-17,9.29-36.49,10.17-42,2-15.26,2-16.14-8.62-5.31-13.26-6.2-12.16-1.54-13.05.89-19.23,21.89-22.77,26.09-12.16,10.17-14.82,11.05S342.16,373,342.16,373Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.39,373.7s-7.07,10.61-8.4,13.93S273,419,273,419s-11.94.88-12.16,1.54-6,9.51-6,10.62v7.07a2.83,2.83,0,0,0,.84.82,22.22,22.22,0,0,0,4.24,3.38c1.55.67,4-.88,3.76-2-.14-.71-.47-2.44-.68-3.58,1.86-1.07,3.48-2.07,3.78-2.17.66-.22,5.52-2.43,7.51-4.2a85.72,85.72,0,0,0,6-6.63s22.78-26.53,26.09-31.18,6.2-13,6.2-13.92,1.1-6.2,1.1-6.2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.68,425.22l.89,3.53s-5.31,6.2-6,8-.89,3.76,4.64.89,7.07-5.09,7.07-5.09a6.8,6.8,0,0,0,5.75-4.2",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.82,323.73s-4.43,15.48-2.66,22.11-4,28.74-4,28.74,6.86,3.54,12.16,3.1,10-6,10-6l3.32-10.39s22.11,19.23,27.64,19.9,13.93-.22,13.93-.22l2.87,1.32L376,374.14l8.85,9.95s32.94-19.9,34.27-22.33,2.65-6,.88-9.51-7.07-17.46-7.07-17.46,14.59,3.31,15.25,4.64,3.32,8,3.32,8l1.1-13.05s-8-11.27-10.61-14.81-13.49-9.73-14.15-10.17-8.4-11.28-15.7-16.58-38.69-6-38.69-6L301.7,319.09Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.81,329.7s4.2,16.8,11.06,19.68,9.73-32.28,8-38.69a22.48,22.48,0,0,0-6.64-10.4l-13,9.07Z",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 326.18,
    y1: 331.77,
    x2: 337.14,
    y2: 331.46,
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.82,323.73s2.43,8.4,3.31,8.84,4.43-.66,4.43-.66,10.17,5.31,11.27,5.75,1.11,1.11,3.76-1.11,7.08-16.8,8-21a47.83,47.83,0,0,0,.66-9.73Z",
    style: {
      fill: "#c9c9c9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "308.56 331.91 312.09 330.14 311.21 327.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.75,333a5.78,5.78,0,0,0,3.31-4.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.22,278.39s-27.72,54.26-27.72,56,15.34,0,36.86-10,45.12-26.54,51.61-33.62,5.3-10.91,2.95-12.09S293.22,278.39,293.22,278.39Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.85,410,345,405.54l.88,2.21,13.71,4-18.57-1.55-.44,1.55,15.91,1.55-21.66,1.77-.22,1.54,20.12-1.1-15.48,4.64.66,2.21,14.37-3.76L347,424.11l.66,2,7.08-4.86-7.3,9.28-8.4,3.32-.44,2.43,7.95-3.09-11.71,14.59,2.43,1.33,16.14-19.68-2.65,11.94,2,1.32,3.09-10.39-1.55,16.81s2,1.32,2,.22,2-15.26,2-15.26l2.21,24.76,2.66-2.21-2.66-20.34L366,461.48l2.43-2.43-5.08-18.58,5.75,7.74.66-2.43-5.08-7.08-.89-6.19,11.72,18.8-4.64-12.16,7.07,9.28-10.17-16.58V429l3.32,3.09,1.1-2.65-4.64-5.09s1.11-5.52-.22-9.73S359.85,410,359.85,410Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.25,358.22l-20.12,44.44L359.85,410s3.54,2.88,5.09,4.2.22,6.63,0,8.62-2.21,2.22.88,3.54,8.85-3.31,10.39-4.2,3.1-4,3.54-6.63,1.11-10.39,1.11-10.39,23.43-31.4,25.64-35.16a61,61,0,0,0,5.31-12.82c.44-2.21-1.55-5.75-1.55-5.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "366.79 426.36 370.48 422.65 372.5 419.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.86,419.51a54.41,54.41,0,0,1-3.79,5.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.72,333.46l23.43,28.08a12.61,12.61,0,0,0,4.87-.22,11.59,11.59,0,0,0,3.76-2s3.75,2.65,7.51,1.55,9.51-11.28,9.29-14.82a17.83,17.83,0,0,0-.66-4.64l-24.1-41.79",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--rice-1--inject-42"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "52.8 419.98 57.34 387.89 52.29 410.38 51.53 381.32 50.02 403.56 46.98 389.66 48.75 410.38 42.94 386.63 45.72 408.36 39.91 395.47 46.98 420.24 52.8 419.98",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.93 419.98 127.48 387.89 122.42 410.38 121.67 381.32 120.15 403.56 117.12 389.66 118.89 410.38 113.07 386.63 115.85 408.36 110.04 395.47 117.12 420.24 122.93 419.98",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.71 419.98 197.26 387.89 192.2 410.38 191.44 381.32 189.93 403.56 186.9 389.66 188.67 410.38 182.85 386.63 185.63 408.36 179.82 395.47 186.9 420.24 192.71 419.98",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.96 419.98 237.41 387.89 242.47 410.38 243.22 381.32 244.74 403.56 247.77 389.66 246 410.38 251.81 386.63 249.04 408.36 254.85 395.47 247.77 420.24 241.96 419.98",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.38 465.64 175.13 428.65 180.96 454.57 181.83 421.08 183.58 446.71 187.07 430.69 185.04 454.57 191.73 427.2 188.53 452.24 195.23 437.39 187.07 465.93 180.38 465.64",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.14 465.64 123.38 428.65 117.56 454.57 116.68 421.08 114.94 446.71 111.44 430.69 113.48 454.57 106.78 427.2 109.98 452.24 103.29 437.39 111.44 465.93 118.14 465.64",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.98 447.99 85.22 411.01 79.39 436.92 78.52 403.43 76.77 429.06 73.28 413.04 75.32 436.92 68.62 409.55 71.82 434.59 65.13 419.74 73.28 448.28 79.98 447.99",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.89 447.99 26.14 411.01 20.31 436.92 19.44 403.43 17.69 429.06 14.2 413.04 16.23 436.92 9.54 409.55 12.74 434.59 6.04 419.74 14.2 448.28 20.89 447.99",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.81 486.9 77.05 449.92 71.23 475.83 70.36 442.34 68.61 467.97 65.11 451.95 67.15 475.83 60.45 448.46 63.66 473.5 56.96 458.65 65.11 487.19 71.81 486.9",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.49 486.9 23.73 449.92 17.91 475.83 17.04 442.34 15.29 467.97 11.79 451.95 13.83 475.83 7.13 448.46 10.34 473.5 3.64 458.65 11.79 487.19 18.49 486.9",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.73 447.99 168.97 411.01 163.15 436.92 162.28 403.43 160.53 429.06 157.03 413.04 159.07 436.92 152.38 409.55 155.58 434.59 148.88 419.74 157.03 448.28 163.73 447.99",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.57 486.9 160.81 449.92 154.99 475.83 154.11 442.34 152.36 467.97 148.87 451.95 150.91 475.83 144.21 448.46 147.41 473.5 140.72 458.65 148.87 487.19 155.57 486.9",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.71 447.99 228.95 411.01 223.12 436.92 222.25 403.43 220.5 429.06 217.01 413.04 219.05 436.92 212.35 409.55 215.55 434.59 208.85 419.74 217.01 448.28 223.71 447.99",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.54 486.9 220.78 449.92 214.96 475.83 214.08 442.34 212.34 467.97 208.84 451.95 210.88 475.83 204.18 448.46 207.38 473.5 200.69 458.65 208.84 487.19 215.54 486.9",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.62 465.64 47.86 428.65 42.03 454.57 41.16 421.08 39.41 446.71 35.92 430.69 37.96 454.57 31.26 427.2 34.46 452.24 27.77 437.39 35.92 465.93 42.62 465.64",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiceField);
export default __webpack_public_path__ + "static/media/rice-field.275c689117b6c9b8e76bff52ee64e44f.svg";
export { ForwardRef as ReactComponent };